/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  Object: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AccountResponse = {
  __typename?: 'AccountResponse';
  accountLink: Scalars['String']['output'];
};

export type AuthenticatedItem = User;

export type Badge = {
  __typename?: 'Badge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<BadgeItem>>;
  itemsCount?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Space>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type BadgeItemsArgs = {
  cursor?: InputMaybe<BadgeItemWhereUniqueInput>;
  orderBy?: Array<BadgeItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BadgeItemWhereInput;
};


export type BadgeItemsCountArgs = {
  where?: BadgeItemWhereInput;
};

export type BadgeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  items?: InputMaybe<BadgeItemRelateToManyForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type BadgeItem = {
  __typename?: 'BadgeItem';
  badge?: Maybe<Badge>;
  coach?: Maybe<Array<Coach>>;
  coachCount?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<Array<User>>;
  userCount?: Maybe<Scalars['Int']['output']>;
};


export type BadgeItemCoachArgs = {
  cursor?: InputMaybe<CoachWhereUniqueInput>;
  orderBy?: Array<CoachOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CoachWhereInput;
};


export type BadgeItemCoachCountArgs = {
  where?: CoachWhereInput;
};


export type BadgeItemUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type BadgeItemUserCountArgs = {
  where?: UserWhereInput;
};

export type BadgeItemCreateInput = {
  badge?: InputMaybe<BadgeRelateToOneForCreateInput>;
  coach?: InputMaybe<CoachRelateToManyForCreateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToManyForCreateInput>;
};

export type BadgeItemManyRelationFilter = {
  every?: InputMaybe<BadgeItemWhereInput>;
  none?: InputMaybe<BadgeItemWhereInput>;
  some?: InputMaybe<BadgeItemWhereInput>;
};

export type BadgeItemOrderByInput = {
  color?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  icon?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type BadgeItemRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<BadgeItemWhereUniqueInput>>;
  create?: InputMaybe<Array<BadgeItemCreateInput>>;
};

export type BadgeItemRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<BadgeItemWhereUniqueInput>>;
  create?: InputMaybe<Array<BadgeItemCreateInput>>;
  disconnect?: InputMaybe<Array<BadgeItemWhereUniqueInput>>;
  set?: InputMaybe<Array<BadgeItemWhereUniqueInput>>;
};

export type BadgeItemRelateToOneForCreateInput = {
  connect?: InputMaybe<BadgeItemWhereUniqueInput>;
  create?: InputMaybe<BadgeItemCreateInput>;
};

export type BadgeItemRelateToOneForUpdateInput = {
  connect?: InputMaybe<BadgeItemWhereUniqueInput>;
  create?: InputMaybe<BadgeItemCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BadgeItemUpdateArgs = {
  data: BadgeItemUpdateInput;
  where: BadgeItemWhereUniqueInput;
};

export type BadgeItemUpdateInput = {
  badge?: InputMaybe<BadgeRelateToOneForUpdateInput>;
  coach?: InputMaybe<CoachRelateToManyForUpdateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToManyForUpdateInput>;
};

export type BadgeItemWhereInput = {
  AND?: InputMaybe<Array<BadgeItemWhereInput>>;
  NOT?: InputMaybe<Array<BadgeItemWhereInput>>;
  OR?: InputMaybe<Array<BadgeItemWhereInput>>;
  badge?: InputMaybe<BadgeWhereInput>;
  coach?: InputMaybe<CoachManyRelationFilter>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserManyRelationFilter>;
};

export type BadgeItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BadgeManyRelationFilter = {
  every?: InputMaybe<BadgeWhereInput>;
  none?: InputMaybe<BadgeWhereInput>;
  some?: InputMaybe<BadgeWhereInput>;
};

export type BadgeOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type BadgeRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<BadgeWhereUniqueInput>>;
  create?: InputMaybe<Array<BadgeCreateInput>>;
};

export type BadgeRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<BadgeWhereUniqueInput>>;
  create?: InputMaybe<Array<BadgeCreateInput>>;
  disconnect?: InputMaybe<Array<BadgeWhereUniqueInput>>;
  set?: InputMaybe<Array<BadgeWhereUniqueInput>>;
};

export type BadgeRelateToOneForCreateInput = {
  connect?: InputMaybe<BadgeWhereUniqueInput>;
  create?: InputMaybe<BadgeCreateInput>;
};

export type BadgeRelateToOneForUpdateInput = {
  connect?: InputMaybe<BadgeWhereUniqueInput>;
  create?: InputMaybe<BadgeCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BadgeUpdateArgs = {
  data: BadgeUpdateInput;
  where: BadgeWhereUniqueInput;
};

export type BadgeUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  items?: InputMaybe<BadgeItemRelateToManyForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type BadgeWhereInput = {
  AND?: InputMaybe<Array<BadgeWhereInput>>;
  NOT?: InputMaybe<Array<BadgeWhereInput>>;
  OR?: InputMaybe<Array<BadgeWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  items?: InputMaybe<BadgeItemManyRelationFilter>;
  name?: InputMaybe<StringFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type BadgeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type CardChecks = {
  __typename?: 'CardChecks';
  address_line1_check?: Maybe<Scalars['String']['output']>;
  address_postal_code_check?: Maybe<Scalars['String']['output']>;
  cvc_check: Scalars['String']['output'];
};

export type CardNetworks = {
  __typename?: 'CardNetworks';
  available: Array<Scalars['String']['output']>;
  preferred?: Maybe<Scalars['String']['output']>;
};

export type ChangeStatusSessionQueueInput = {
  changeDate: Scalars['String']['input'];
  finishedAt: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  startedAt: Scalars['String']['input'];
  status: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ClassOffered = {
  __typename?: 'ClassOffered';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  image?: Maybe<ImageFieldOutput>;
  name?: Maybe<Scalars['String']['output']>;
  schedules?: Maybe<Array<ClassOfferedSchedule>>;
  schedulesCount?: Maybe<Scalars['Int']['output']>;
  short_summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type ClassOfferedSchedulesArgs = {
  cursor?: InputMaybe<ClassOfferedScheduleWhereUniqueInput>;
  orderBy?: Array<ClassOfferedScheduleOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClassOfferedScheduleWhereInput;
};


export type ClassOfferedSchedulesCountArgs = {
  where?: ClassOfferedScheduleWhereInput;
};

export type ClassOfferedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedules?: InputMaybe<ClassOfferedScheduleRelateToManyForCreateInput>;
  short_summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type ClassOfferedManyRelationFilter = {
  every?: InputMaybe<ClassOfferedWhereInput>;
  none?: InputMaybe<ClassOfferedWhereInput>;
  some?: InputMaybe<ClassOfferedWhereInput>;
};

export type ClassOfferedOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  short_summary?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type ClassOfferedRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ClassOfferedWhereUniqueInput>>;
  create?: InputMaybe<Array<ClassOfferedCreateInput>>;
};

export type ClassOfferedRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ClassOfferedWhereUniqueInput>>;
  create?: InputMaybe<Array<ClassOfferedCreateInput>>;
  disconnect?: InputMaybe<Array<ClassOfferedWhereUniqueInput>>;
  set?: InputMaybe<Array<ClassOfferedWhereUniqueInput>>;
};

export type ClassOfferedSchedule = {
  __typename?: 'ClassOfferedSchedule';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  day?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  startTime?: Maybe<Scalars['DateTime']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type ClassOfferedScheduleCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  day?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type ClassOfferedScheduleManyRelationFilter = {
  every?: InputMaybe<ClassOfferedScheduleWhereInput>;
  none?: InputMaybe<ClassOfferedScheduleWhereInput>;
  some?: InputMaybe<ClassOfferedScheduleWhereInput>;
};

export type ClassOfferedScheduleOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  day?: InputMaybe<OrderDirection>;
  endTime?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  startTime?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type ClassOfferedScheduleRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ClassOfferedScheduleWhereUniqueInput>>;
  create?: InputMaybe<Array<ClassOfferedScheduleCreateInput>>;
};

export type ClassOfferedScheduleRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ClassOfferedScheduleWhereUniqueInput>>;
  create?: InputMaybe<Array<ClassOfferedScheduleCreateInput>>;
  disconnect?: InputMaybe<Array<ClassOfferedScheduleWhereUniqueInput>>;
  set?: InputMaybe<Array<ClassOfferedScheduleWhereUniqueInput>>;
};

export type ClassOfferedScheduleUpdateArgs = {
  data: ClassOfferedScheduleUpdateInput;
  where: ClassOfferedScheduleWhereUniqueInput;
};

export type ClassOfferedScheduleUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  day?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type ClassOfferedScheduleWhereInput = {
  AND?: InputMaybe<Array<ClassOfferedScheduleWhereInput>>;
  NOT?: InputMaybe<Array<ClassOfferedScheduleWhereInput>>;
  OR?: InputMaybe<Array<ClassOfferedScheduleWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  day?: InputMaybe<StringFilter>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IdFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type ClassOfferedScheduleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ClassOfferedUpdateArgs = {
  data: ClassOfferedUpdateInput;
  where: ClassOfferedWhereUniqueInput;
};

export type ClassOfferedUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  image?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedules?: InputMaybe<ClassOfferedScheduleRelateToManyForUpdateInput>;
  short_summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type ClassOfferedWhereInput = {
  AND?: InputMaybe<Array<ClassOfferedWhereInput>>;
  NOT?: InputMaybe<Array<ClassOfferedWhereInput>>;
  OR?: InputMaybe<Array<ClassOfferedWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  schedules?: InputMaybe<ClassOfferedScheduleManyRelationFilter>;
  short_summary?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type ClassOfferedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ClientsAssociated = {
  __typename?: 'ClientsAssociated';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  space?: Maybe<Space>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type ClientsAssociatedCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type ClientsAssociatedManyRelationFilter = {
  every?: InputMaybe<ClientsAssociatedWhereInput>;
  none?: InputMaybe<ClientsAssociatedWhereInput>;
  some?: InputMaybe<ClientsAssociatedWhereInput>;
};

export type ClientsAssociatedOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type ClientsAssociatedRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ClientsAssociatedWhereUniqueInput>>;
  create?: InputMaybe<Array<ClientsAssociatedCreateInput>>;
};

export type ClientsAssociatedRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ClientsAssociatedWhereUniqueInput>>;
  create?: InputMaybe<Array<ClientsAssociatedCreateInput>>;
  disconnect?: InputMaybe<Array<ClientsAssociatedWhereUniqueInput>>;
  set?: InputMaybe<Array<ClientsAssociatedWhereUniqueInput>>;
};

export type ClientsAssociatedUpdateArgs = {
  data: ClientsAssociatedUpdateInput;
  where: ClientsAssociatedWhereUniqueInput;
};

export type ClientsAssociatedUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type ClientsAssociatedWhereInput = {
  AND?: InputMaybe<Array<ClientsAssociatedWhereInput>>;
  NOT?: InputMaybe<Array<ClientsAssociatedWhereInput>>;
  OR?: InputMaybe<Array<ClientsAssociatedWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type ClientsAssociatedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Coach = {
  __typename?: 'Coach';
  avatar?: Maybe<ImageFieldOutput>;
  badges?: Maybe<Array<BadgeItem>>;
  badgesCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type CoachBadgesArgs = {
  cursor?: InputMaybe<BadgeItemWhereUniqueInput>;
  orderBy?: Array<BadgeItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BadgeItemWhereInput;
};


export type CoachBadgesCountArgs = {
  where?: BadgeItemWhereInput;
};


export type CoachSessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionWhereInput;
};


export type CoachSessionsCountArgs = {
  where?: SessionWhereInput;
};

export type CoachCreateInput = {
  avatar?: InputMaybe<ImageFieldInput>;
  badges?: InputMaybe<BadgeItemRelateToManyForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionRelateToManyForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type CoachManyRelationFilter = {
  every?: InputMaybe<CoachWhereInput>;
  none?: InputMaybe<CoachWhereInput>;
  some?: InputMaybe<CoachWhereInput>;
};

export type CoachOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  firstName?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lastName?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type CoachRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<CoachWhereUniqueInput>>;
  create?: InputMaybe<Array<CoachCreateInput>>;
};

export type CoachRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<CoachWhereUniqueInput>>;
  create?: InputMaybe<Array<CoachCreateInput>>;
  disconnect?: InputMaybe<Array<CoachWhereUniqueInput>>;
  set?: InputMaybe<Array<CoachWhereUniqueInput>>;
};

export type CoachRelateToOneForCreateInput = {
  connect?: InputMaybe<CoachWhereUniqueInput>;
  create?: InputMaybe<CoachCreateInput>;
};

export type CoachRelateToOneForUpdateInput = {
  connect?: InputMaybe<CoachWhereUniqueInput>;
  create?: InputMaybe<CoachCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CoachUpdateArgs = {
  data: CoachUpdateInput;
  where: CoachWhereUniqueInput;
};

export type CoachUpdateInput = {
  avatar?: InputMaybe<ImageFieldInput>;
  badges?: InputMaybe<BadgeItemRelateToManyForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionRelateToManyForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type CoachWhereInput = {
  AND?: InputMaybe<Array<CoachWhereInput>>;
  NOT?: InputMaybe<Array<CoachWhereInput>>;
  OR?: InputMaybe<Array<CoachWhereInput>>;
  badges?: InputMaybe<BadgeItemManyRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  lastName?: InputMaybe<StringFilter>;
  sessions?: InputMaybe<SessionManyRelationFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type CoachWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Competitor = {
  __typename?: 'Competitor';
  avatar?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  sessionsCount: Scalars['Int']['output'];
};

export type CreateInitialUserInput = {
  devices?: InputMaybe<DeviceRelateToManyForCreateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAccessCMS?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<UserLangType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateNotificationsInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  sendToEmail: Scalars['Boolean']['input'];
  spaceId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  users: SendUserNotificationTemplateInput;
};

export type CreateReportTotals = {
  endDate: Scalars['DateTime']['input'];
  spaceId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type CreateSubscriptionForSessionData = {
  sessionId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSubscriptionInput = {
  amount: Scalars['Int']['input'];
  creditId: Scalars['String']['input'];
  dayOfMonth: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  spaceId: Scalars['String']['input'];
};

export type CreateSubscriptionResult = {
  __typename?: 'CreateSubscriptionResult';
  id: Scalars['String']['output'];
};

export type Credit = {
  __typename?: 'Credit';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  creditAvailable?: Maybe<Scalars['Int']['output']>;
  creditBuy?: Maybe<Scalars['Int']['output']>;
  creditUsed?: Maybe<Scalars['Int']['output']>;
  expiredAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  openAt?: Maybe<Scalars['DateTime']['output']>;
  payment?: Maybe<Payment>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Plan>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionRefId?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<SessionSubscription>>;
  subscriptionsCount?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};


export type CreditSubscriptionsArgs = {
  cursor?: InputMaybe<SessionSubscriptionWhereUniqueInput>;
  orderBy?: Array<SessionSubscriptionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionSubscriptionWhereInput;
};


export type CreditSubscriptionsCountArgs = {
  where?: SessionSubscriptionWhereInput;
};

export type CreditCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  creditBuy?: InputMaybe<Scalars['Int']['input']>;
  creditUsed?: InputMaybe<Scalars['Int']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  openAt?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<PaymentRelateToOneForCreateInput>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<PlanRelateToOneForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionRefId?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForCreateInput>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type CreditManyRelationFilter = {
  every?: InputMaybe<CreditWhereInput>;
  none?: InputMaybe<CreditWhereInput>;
  some?: InputMaybe<CreditWhereInput>;
};

export type CreditOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  creditBuy?: InputMaybe<OrderDirection>;
  creditUsed?: InputMaybe<OrderDirection>;
  expiredAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  openAt?: InputMaybe<OrderDirection>;
  paymentMethod?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  subscriptionRefId?: InputMaybe<OrderDirection>;
  totalPrice?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type CreditRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<CreditWhereUniqueInput>>;
  create?: InputMaybe<Array<CreditCreateInput>>;
};

export type CreditRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<CreditWhereUniqueInput>>;
  create?: InputMaybe<Array<CreditCreateInput>>;
  disconnect?: InputMaybe<Array<CreditWhereUniqueInput>>;
  set?: InputMaybe<Array<CreditWhereUniqueInput>>;
};

export type CreditRelateToOneForCreateInput = {
  connect?: InputMaybe<CreditWhereUniqueInput>;
  create?: InputMaybe<CreditCreateInput>;
};

export type CreditRelateToOneForUpdateInput = {
  connect?: InputMaybe<CreditWhereUniqueInput>;
  create?: InputMaybe<CreditCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreditUpdateArgs = {
  data: CreditUpdateInput;
  where: CreditWhereUniqueInput;
};

export type CreditUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  creditBuy?: InputMaybe<Scalars['Int']['input']>;
  creditUsed?: InputMaybe<Scalars['Int']['input']>;
  expiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  openAt?: InputMaybe<Scalars['DateTime']['input']>;
  payment?: InputMaybe<PaymentRelateToOneForUpdateInput>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<PlanRelateToOneForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptionRefId?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForUpdateInput>;
  totalPrice?: InputMaybe<Scalars['Decimal']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type CreditWhereInput = {
  AND?: InputMaybe<Array<CreditWhereInput>>;
  NOT?: InputMaybe<Array<CreditWhereInput>>;
  OR?: InputMaybe<Array<CreditWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  creditBuy?: InputMaybe<IntFilter>;
  creditUsed?: InputMaybe<IntNullableFilter>;
  expiredAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  openAt?: InputMaybe<DateTimeFilter>;
  payment?: InputMaybe<PaymentWhereInput>;
  paymentMethod?: InputMaybe<StringFilter>;
  plan?: InputMaybe<PlanWhereInput>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  subscriptionRefId?: InputMaybe<StringFilter>;
  subscriptions?: InputMaybe<SessionSubscriptionManyRelationFilter>;
  totalPrice?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type CreditWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<DecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type Device = {
  __typename?: 'Device';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  device_manufacturer?: Maybe<Scalars['String']['output']>;
  device_model?: Maybe<Scalars['String']['output']>;
  device_name?: Maybe<Scalars['String']['output']>;
  device_platform?: Maybe<Scalars['String']['output']>;
  device_system_version?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastSession?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type DeviceCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_platform?: InputMaybe<Scalars['String']['input']>;
  device_system_version?: InputMaybe<Scalars['String']['input']>;
  lastSession?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type DeviceInfo = {
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_platform?: InputMaybe<Scalars['String']['input']>;
  device_system_version?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type DeviceManyRelationFilter = {
  every?: InputMaybe<DeviceWhereInput>;
  none?: InputMaybe<DeviceWhereInput>;
  some?: InputMaybe<DeviceWhereInput>;
};

export type DeviceOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  device_manufacturer?: InputMaybe<OrderDirection>;
  device_model?: InputMaybe<OrderDirection>;
  device_name?: InputMaybe<OrderDirection>;
  device_platform?: InputMaybe<OrderDirection>;
  device_system_version?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lastSession?: InputMaybe<OrderDirection>;
  state?: InputMaybe<OrderDirection>;
  token?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type DeviceRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  create?: InputMaybe<Array<DeviceCreateInput>>;
};

export type DeviceRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  create?: InputMaybe<Array<DeviceCreateInput>>;
  disconnect?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  set?: InputMaybe<Array<DeviceWhereUniqueInput>>;
};

export type DeviceUpdateArgs = {
  data: DeviceUpdateInput;
  where: DeviceWhereUniqueInput;
};

export type DeviceUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  device_manufacturer?: InputMaybe<Scalars['String']['input']>;
  device_model?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_platform?: InputMaybe<Scalars['String']['input']>;
  device_system_version?: InputMaybe<Scalars['String']['input']>;
  lastSession?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type DeviceWhereInput = {
  AND?: InputMaybe<Array<DeviceWhereInput>>;
  NOT?: InputMaybe<Array<DeviceWhereInput>>;
  OR?: InputMaybe<Array<DeviceWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  device_manufacturer?: InputMaybe<StringFilter>;
  device_model?: InputMaybe<StringFilter>;
  device_name?: InputMaybe<StringFilter>;
  device_platform?: InputMaybe<StringFilter>;
  device_system_version?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  lastSession?: InputMaybe<DateTimeNullableFilter>;
  state?: InputMaybe<StringNullableFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type DeviceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FilterTimeEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum FrequencyInputEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum ImageExtension {
  Gif = 'gif',
  Jpg = 'jpg',
  Png = 'png',
  Webp = 'webp'
}

export type ImageFieldInput = {
  upload: Scalars['Upload']['input'];
};

export type ImageFieldOutput = {
  __typename?: 'ImageFieldOutput';
  extension: ImageExtension;
  filesize: Scalars['Int']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String']['input'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String']['output'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  isFilterable: Scalars['Boolean']['output'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean']['output'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String']['output'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String']['output'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int']['output'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiGraphQl = {
  __typename?: 'KeystoneAdminUIGraphQL';
  names: KeystoneAdminUiGraphQlNames;
};

export type KeystoneAdminUiGraphQlNames = {
  __typename?: 'KeystoneAdminUIGraphQLNames';
  createInputName: Scalars['String']['output'];
  createManyMutationName: Scalars['String']['output'];
  createMutationName: Scalars['String']['output'];
  deleteManyMutationName: Scalars['String']['output'];
  deleteMutationName: Scalars['String']['output'];
  itemQueryName: Scalars['String']['output'];
  listOrderName: Scalars['String']['output'];
  listQueryCountName: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  outputTypeName: Scalars['String']['output'];
  relateToManyForCreateInputName: Scalars['String']['output'];
  relateToManyForUpdateInputName: Scalars['String']['output'];
  relateToOneForCreateInputName: Scalars['String']['output'];
  relateToOneForUpdateInputName: Scalars['String']['output'];
  updateInputName: Scalars['String']['output'];
  updateManyInputName: Scalars['String']['output'];
  updateManyMutationName: Scalars['String']['output'];
  updateMutationName: Scalars['String']['output'];
  whereInputName: Scalars['String']['output'];
  whereUniqueInputName: Scalars['String']['output'];
};

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  graphql: KeystoneAdminUiGraphQl;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean']['output'];
  hideDelete: Scalars['Boolean']['output'];
  initialColumns: Array<Scalars['String']['output']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  itemQueryName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelField: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  pageSize: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  singular: Scalars['String']['output'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String']['output'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export type Language = {
  __typename?: 'Language';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  definitions?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type LanguageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  definitions?: InputMaybe<Scalars['JSON']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type LanguageOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lang?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type LanguageUpdateArgs = {
  data: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  definitions?: InputMaybe<Scalars['JSON']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type LanguageWhereInput = {
  AND?: InputMaybe<Array<LanguageWhereInput>>;
  NOT?: InputMaybe<Array<LanguageWhereInput>>;
  OR?: InputMaybe<Array<LanguageWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  lang?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type LanguageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type LinkAccountInput = {
  accountId: Scalars['String']['input'];
  callbackPath: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  authenticateBackofficeUserWithFirebase?: Maybe<UserAuthenticationWithPasswordResult>;
  authenticateUserWithFirebase?: Maybe<UserAuthenticationWithPasswordResult>;
  authenticateUserWithPassword?: Maybe<UserAuthenticationWithPasswordResult>;
  authenticationCloseSession?: Maybe<Scalars['Boolean']['output']>;
  cancelSubscription: StripeSubscription;
  changeStatusSessionQueue?: Maybe<Session>;
  completeProfileBackoffice?: Maybe<Scalars['Boolean']['output']>;
  createBadge?: Maybe<Badge>;
  createBadgeItem?: Maybe<BadgeItem>;
  createBadgeItems?: Maybe<Array<Maybe<BadgeItem>>>;
  createBadges?: Maybe<Array<Maybe<Badge>>>;
  createClassOffered?: Maybe<ClassOffered>;
  createClassOfferedSchedule?: Maybe<ClassOfferedSchedule>;
  createClassOfferedSchedules?: Maybe<Array<Maybe<ClassOfferedSchedule>>>;
  createClassOffereds?: Maybe<Array<Maybe<ClassOffered>>>;
  createClientsAssociated?: Maybe<ClientsAssociated>;
  createClientsAssociateds?: Maybe<Array<Maybe<ClientsAssociated>>>;
  createCoach?: Maybe<Coach>;
  createCoaches?: Maybe<Array<Maybe<Coach>>>;
  createCredit?: Maybe<Credit>;
  createCredits?: Maybe<Array<Maybe<Credit>>>;
  createCustomerId: User;
  createDevice?: Maybe<Device>;
  createDevices?: Maybe<Array<Maybe<Device>>>;
  createInitialUser: UserAuthenticationWithPasswordSuccess;
  createLanguage?: Maybe<Language>;
  createLanguages?: Maybe<Array<Maybe<Language>>>;
  createPayment?: Maybe<Payment>;
  createPaymentIntent: StripePaymentIntentData;
  createPayments?: Maybe<Array<Maybe<Payment>>>;
  createPaymentsProvider?: Maybe<PaymentsProvider>;
  createPaymentsProviders?: Maybe<Array<Maybe<PaymentsProvider>>>;
  createPlan?: Maybe<Plan>;
  createPlans?: Maybe<Array<Maybe<Plan>>>;
  createRepeatSession?: Maybe<RepeatSession>;
  createRepeatSessions?: Maybe<Array<Maybe<RepeatSession>>>;
  createSession?: Maybe<Session>;
  createSessionCategories?: Maybe<Array<Maybe<SessionCategory>>>;
  createSessionCategory?: Maybe<SessionCategory>;
  createSessionSubscription?: Maybe<SessionSubscription>;
  createSessionSubscriptions?: Maybe<Array<Maybe<SessionSubscription>>>;
  createSessions?: Maybe<Array<Maybe<Session>>>;
  createSpace?: Maybe<Space>;
  createSpaceRequest?: Maybe<SpaceRequest>;
  createSpaceRequests?: Maybe<Array<Maybe<SpaceRequest>>>;
  createSpaces?: Maybe<Array<Maybe<Space>>>;
  createStripeAccount: AccountResponse;
  createSubscription: CreateSubscriptionResult;
  createSubscriptionForSession?: Maybe<SessionSubscription>;
  createUser?: Maybe<User>;
  createUserBackoffice?: Maybe<UserBackoffice>;
  createUserBackoffices?: Maybe<Array<Maybe<UserBackoffice>>>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  deleteAccount: User;
  deleteAllSessionForEventBackoffice?: Maybe<Array<Maybe<Session>>>;
  deleteBadge?: Maybe<Badge>;
  deleteBadgeItem?: Maybe<BadgeItem>;
  deleteBadgeItems?: Maybe<Array<Maybe<BadgeItem>>>;
  deleteBadges?: Maybe<Array<Maybe<Badge>>>;
  deleteClassOffered?: Maybe<ClassOffered>;
  deleteClassOfferedSchedule?: Maybe<ClassOfferedSchedule>;
  deleteClassOfferedSchedules?: Maybe<Array<Maybe<ClassOfferedSchedule>>>;
  deleteClassOffereds?: Maybe<Array<Maybe<ClassOffered>>>;
  deleteClientsAssociated?: Maybe<ClientsAssociated>;
  deleteClientsAssociateds?: Maybe<Array<Maybe<ClientsAssociated>>>;
  deleteCoach?: Maybe<Coach>;
  deleteCoaches?: Maybe<Array<Maybe<Coach>>>;
  deleteCredit?: Maybe<Credit>;
  deleteCredits?: Maybe<Array<Maybe<Credit>>>;
  deleteDevice?: Maybe<Device>;
  deleteDevices?: Maybe<Array<Maybe<Device>>>;
  deleteLanguage?: Maybe<Language>;
  deleteLanguages?: Maybe<Array<Maybe<Language>>>;
  deletePayment?: Maybe<Payment>;
  deletePaymentMethod: Scalars['Boolean']['output'];
  deletePayments?: Maybe<Array<Maybe<Payment>>>;
  deletePaymentsProvider?: Maybe<PaymentsProvider>;
  deletePaymentsProviders?: Maybe<Array<Maybe<PaymentsProvider>>>;
  deletePlan?: Maybe<Plan>;
  deletePlans?: Maybe<Array<Maybe<Plan>>>;
  deleteRepeatSession?: Maybe<RepeatSession>;
  deleteRepeatSessions?: Maybe<Array<Maybe<RepeatSession>>>;
  deleteSession?: Maybe<Session>;
  deleteSessionCategories?: Maybe<Array<Maybe<SessionCategory>>>;
  deleteSessionCategory?: Maybe<SessionCategory>;
  deleteSessionSubscription?: Maybe<SessionSubscription>;
  deleteSessionSubscriptions?: Maybe<Array<Maybe<SessionSubscription>>>;
  deleteSessions?: Maybe<Array<Maybe<Session>>>;
  deleteSpace?: Maybe<Space>;
  deleteSpaceRequest?: Maybe<SpaceRequest>;
  deleteSpaceRequests?: Maybe<Array<Maybe<SpaceRequest>>>;
  deleteSpaces?: Maybe<Array<Maybe<Space>>>;
  deleteSubscriptionForSession?: Maybe<SessionSubscription>;
  deleteUser?: Maybe<User>;
  deleteUserBackoffice?: Maybe<UserBackoffice>;
  deleteUserBackoffices?: Maybe<Array<Maybe<UserBackoffice>>>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  endSession: Scalars['Boolean']['output'];
  joinToSpace?: Maybe<Space>;
  linkStripeAccount: AccountResponse;
  loginStripeAccount: StripeLoginResponse;
  sendNotification: Array<Maybe<Scalars['Object']['output']>>;
  setDefaultSourceMethod: Scalars['Boolean']['output'];
  updateAllSessionForEventBackoffice?: Maybe<Array<Maybe<Session>>>;
  updateBadge?: Maybe<Badge>;
  updateBadgeItem?: Maybe<BadgeItem>;
  updateBadgeItems?: Maybe<Array<Maybe<BadgeItem>>>;
  updateBadges?: Maybe<Array<Maybe<Badge>>>;
  updateClassOffered?: Maybe<ClassOffered>;
  updateClassOfferedSchedule?: Maybe<ClassOfferedSchedule>;
  updateClassOfferedSchedules?: Maybe<Array<Maybe<ClassOfferedSchedule>>>;
  updateClassOffereds?: Maybe<Array<Maybe<ClassOffered>>>;
  updateClientsAssociated?: Maybe<ClientsAssociated>;
  updateClientsAssociateds?: Maybe<Array<Maybe<ClientsAssociated>>>;
  updateCoach?: Maybe<Coach>;
  updateCoaches?: Maybe<Array<Maybe<Coach>>>;
  updateCredit?: Maybe<Credit>;
  updateCredits?: Maybe<Array<Maybe<Credit>>>;
  updateDevice?: Maybe<Device>;
  updateDevices?: Maybe<Array<Maybe<Device>>>;
  updateLanguage?: Maybe<Language>;
  updateLanguages?: Maybe<Array<Maybe<Language>>>;
  updatePayment?: Maybe<Payment>;
  updatePayments?: Maybe<Array<Maybe<Payment>>>;
  updatePaymentsProvider?: Maybe<PaymentsProvider>;
  updatePaymentsProviders?: Maybe<Array<Maybe<PaymentsProvider>>>;
  updatePlan?: Maybe<Plan>;
  updatePlans?: Maybe<Array<Maybe<Plan>>>;
  updateRepeatSession?: Maybe<RepeatSession>;
  updateRepeatSessions?: Maybe<Array<Maybe<RepeatSession>>>;
  updateSession?: Maybe<Session>;
  updateSessionCategories?: Maybe<Array<Maybe<SessionCategory>>>;
  updateSessionCategory?: Maybe<SessionCategory>;
  updateSessionSubscription?: Maybe<SessionSubscription>;
  updateSessionSubscriptions?: Maybe<Array<Maybe<SessionSubscription>>>;
  updateSessions?: Maybe<Array<Maybe<Session>>>;
  updateSpace?: Maybe<Space>;
  updateSpaceByService?: Maybe<Space>;
  updateSpaceRequest?: Maybe<SpaceRequest>;
  updateSpaceRequests?: Maybe<Array<Maybe<SpaceRequest>>>;
  updateSpaces?: Maybe<Array<Maybe<Space>>>;
  updateUser?: Maybe<User>;
  updateUserBackoffice?: Maybe<UserBackoffice>;
  updateUserBackoffices?: Maybe<Array<Maybe<UserBackoffice>>>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
  verifyExistEmail?: Maybe<VerifyExistEmailResult>;
  verifyExistUserInDB?: Maybe<Scalars['Boolean']['output']>;
  verifyStripeAccount: VerifyStripeAccountResult;
};


export type MutationAuthenticateBackofficeUserWithFirebaseArgs = {
  token: Scalars['String']['input'];
};


export type MutationAuthenticateUserWithFirebaseArgs = {
  device?: InputMaybe<DeviceInfo>;
  token: Scalars['String']['input'];
};


export type MutationAuthenticateUserWithPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationAuthenticationCloseSessionArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCancelSubscriptionArgs = {
  subscriptionId: Scalars['String']['input'];
};


export type MutationChangeStatusSessionQueueArgs = {
  data: ChangeStatusSessionQueueInput;
};


export type MutationCompleteProfileBackofficeArgs = {
  firebaseUID?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationCreateBadgeArgs = {
  data: BadgeCreateInput;
};


export type MutationCreateBadgeItemArgs = {
  data: BadgeItemCreateInput;
};


export type MutationCreateBadgeItemsArgs = {
  data: Array<BadgeItemCreateInput>;
};


export type MutationCreateBadgesArgs = {
  data: Array<BadgeCreateInput>;
};


export type MutationCreateClassOfferedArgs = {
  data: ClassOfferedCreateInput;
};


export type MutationCreateClassOfferedScheduleArgs = {
  data: ClassOfferedScheduleCreateInput;
};


export type MutationCreateClassOfferedSchedulesArgs = {
  data: Array<ClassOfferedScheduleCreateInput>;
};


export type MutationCreateClassOfferedsArgs = {
  data: Array<ClassOfferedCreateInput>;
};


export type MutationCreateClientsAssociatedArgs = {
  data: ClientsAssociatedCreateInput;
};


export type MutationCreateClientsAssociatedsArgs = {
  data: Array<ClientsAssociatedCreateInput>;
};


export type MutationCreateCoachArgs = {
  data: CoachCreateInput;
};


export type MutationCreateCoachesArgs = {
  data: Array<CoachCreateInput>;
};


export type MutationCreateCreditArgs = {
  data: CreditCreateInput;
};


export type MutationCreateCreditsArgs = {
  data: Array<CreditCreateInput>;
};


export type MutationCreateDeviceArgs = {
  data: DeviceCreateInput;
};


export type MutationCreateDevicesArgs = {
  data: Array<DeviceCreateInput>;
};


export type MutationCreateInitialUserArgs = {
  data: CreateInitialUserInput;
};


export type MutationCreateLanguageArgs = {
  data: LanguageCreateInput;
};


export type MutationCreateLanguagesArgs = {
  data: Array<LanguageCreateInput>;
};


export type MutationCreatePaymentArgs = {
  data: PaymentCreateInput;
};


export type MutationCreatePaymentsArgs = {
  data: Array<PaymentCreateInput>;
};


export type MutationCreatePaymentsProviderArgs = {
  data: PaymentsProviderCreateInput;
};


export type MutationCreatePaymentsProvidersArgs = {
  data: Array<PaymentsProviderCreateInput>;
};


export type MutationCreatePlanArgs = {
  data: PlanCreateInput;
};


export type MutationCreatePlansArgs = {
  data: Array<PlanCreateInput>;
};


export type MutationCreateRepeatSessionArgs = {
  data: RepeatSessionCreateInput;
};


export type MutationCreateRepeatSessionsArgs = {
  data: Array<RepeatSessionCreateInput>;
};


export type MutationCreateSessionArgs = {
  data: SessionCreateInput;
};


export type MutationCreateSessionCategoriesArgs = {
  data: Array<SessionCategoryCreateInput>;
};


export type MutationCreateSessionCategoryArgs = {
  data: SessionCategoryCreateInput;
};


export type MutationCreateSessionSubscriptionArgs = {
  data: SessionSubscriptionCreateInput;
};


export type MutationCreateSessionSubscriptionsArgs = {
  data: Array<SessionSubscriptionCreateInput>;
};


export type MutationCreateSessionsArgs = {
  data: Array<SessionCreateInput>;
};


export type MutationCreateSpaceArgs = {
  data: SpaceCreateInput;
};


export type MutationCreateSpaceRequestArgs = {
  data: SpaceRequestCreateInput;
};


export type MutationCreateSpaceRequestsArgs = {
  data: Array<SpaceRequestCreateInput>;
};


export type MutationCreateSpacesArgs = {
  data: Array<SpaceCreateInput>;
};


export type MutationCreateStripeAccountArgs = {
  spaceId: Scalars['ID']['input'];
};


export type MutationCreateSubscriptionArgs = {
  data: CreateSubscriptionInput;
};


export type MutationCreateSubscriptionForSessionArgs = {
  data: CreateSubscriptionForSessionData;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUserBackofficeArgs = {
  data: UserBackofficeCreateInput;
};


export type MutationCreateUserBackofficesArgs = {
  data: Array<UserBackofficeCreateInput>;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationDeleteAllSessionForEventBackofficeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBadgeArgs = {
  where: BadgeWhereUniqueInput;
};


export type MutationDeleteBadgeItemArgs = {
  where: BadgeItemWhereUniqueInput;
};


export type MutationDeleteBadgeItemsArgs = {
  where: Array<BadgeItemWhereUniqueInput>;
};


export type MutationDeleteBadgesArgs = {
  where: Array<BadgeWhereUniqueInput>;
};


export type MutationDeleteClassOfferedArgs = {
  where: ClassOfferedWhereUniqueInput;
};


export type MutationDeleteClassOfferedScheduleArgs = {
  where: ClassOfferedScheduleWhereUniqueInput;
};


export type MutationDeleteClassOfferedSchedulesArgs = {
  where: Array<ClassOfferedScheduleWhereUniqueInput>;
};


export type MutationDeleteClassOfferedsArgs = {
  where: Array<ClassOfferedWhereUniqueInput>;
};


export type MutationDeleteClientsAssociatedArgs = {
  where: ClientsAssociatedWhereUniqueInput;
};


export type MutationDeleteClientsAssociatedsArgs = {
  where: Array<ClientsAssociatedWhereUniqueInput>;
};


export type MutationDeleteCoachArgs = {
  where: CoachWhereUniqueInput;
};


export type MutationDeleteCoachesArgs = {
  where: Array<CoachWhereUniqueInput>;
};


export type MutationDeleteCreditArgs = {
  where: CreditWhereUniqueInput;
};


export type MutationDeleteCreditsArgs = {
  where: Array<CreditWhereUniqueInput>;
};


export type MutationDeleteDeviceArgs = {
  where: DeviceWhereUniqueInput;
};


export type MutationDeleteDevicesArgs = {
  where: Array<DeviceWhereUniqueInput>;
};


export type MutationDeleteLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type MutationDeleteLanguagesArgs = {
  where: Array<LanguageWhereUniqueInput>;
};


export type MutationDeletePaymentArgs = {
  where: PaymentWhereUniqueInput;
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationDeletePaymentsArgs = {
  where: Array<PaymentWhereUniqueInput>;
};


export type MutationDeletePaymentsProviderArgs = {
  where: PaymentsProviderWhereUniqueInput;
};


export type MutationDeletePaymentsProvidersArgs = {
  where: Array<PaymentsProviderWhereUniqueInput>;
};


export type MutationDeletePlanArgs = {
  where: PlanWhereUniqueInput;
};


export type MutationDeletePlansArgs = {
  where: Array<PlanWhereUniqueInput>;
};


export type MutationDeleteRepeatSessionArgs = {
  where: RepeatSessionWhereUniqueInput;
};


export type MutationDeleteRepeatSessionsArgs = {
  where: Array<RepeatSessionWhereUniqueInput>;
};


export type MutationDeleteSessionArgs = {
  where: SessionWhereUniqueInput;
};


export type MutationDeleteSessionCategoriesArgs = {
  where: Array<SessionCategoryWhereUniqueInput>;
};


export type MutationDeleteSessionCategoryArgs = {
  where: SessionCategoryWhereUniqueInput;
};


export type MutationDeleteSessionSubscriptionArgs = {
  where: SessionSubscriptionWhereUniqueInput;
};


export type MutationDeleteSessionSubscriptionsArgs = {
  where: Array<SessionSubscriptionWhereUniqueInput>;
};


export type MutationDeleteSessionsArgs = {
  where: Array<SessionWhereUniqueInput>;
};


export type MutationDeleteSpaceArgs = {
  where: SpaceWhereUniqueInput;
};


export type MutationDeleteSpaceRequestArgs = {
  where: SpaceRequestWhereUniqueInput;
};


export type MutationDeleteSpaceRequestsArgs = {
  where: Array<SpaceRequestWhereUniqueInput>;
};


export type MutationDeleteSpacesArgs = {
  where: Array<SpaceWhereUniqueInput>;
};


export type MutationDeleteSubscriptionForSessionArgs = {
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUserBackofficeArgs = {
  where: UserBackofficeWhereUniqueInput;
};


export type MutationDeleteUserBackofficesArgs = {
  where: Array<UserBackofficeWhereUniqueInput>;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationJoinToSpaceArgs = {
  spaceId: Scalars['ID']['input'];
};


export type MutationLinkStripeAccountArgs = {
  accountId: Scalars['String']['input'];
};


export type MutationLoginStripeAccountArgs = {
  spaceId: Scalars['ID']['input'];
};


export type MutationSendNotificationArgs = {
  data: CreateNotificationsInput;
};


export type MutationSetDefaultSourceMethodArgs = {
  paymentMethodId: Scalars['String']['input'];
};


export type MutationUpdateAllSessionForEventBackofficeArgs = {
  data: UpdateAllSessionForEventBackofficeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBadgeArgs = {
  data: BadgeUpdateInput;
  where: BadgeWhereUniqueInput;
};


export type MutationUpdateBadgeItemArgs = {
  data: BadgeItemUpdateInput;
  where: BadgeItemWhereUniqueInput;
};


export type MutationUpdateBadgeItemsArgs = {
  data: Array<BadgeItemUpdateArgs>;
};


export type MutationUpdateBadgesArgs = {
  data: Array<BadgeUpdateArgs>;
};


export type MutationUpdateClassOfferedArgs = {
  data: ClassOfferedUpdateInput;
  where: ClassOfferedWhereUniqueInput;
};


export type MutationUpdateClassOfferedScheduleArgs = {
  data: ClassOfferedScheduleUpdateInput;
  where: ClassOfferedScheduleWhereUniqueInput;
};


export type MutationUpdateClassOfferedSchedulesArgs = {
  data: Array<ClassOfferedScheduleUpdateArgs>;
};


export type MutationUpdateClassOfferedsArgs = {
  data: Array<ClassOfferedUpdateArgs>;
};


export type MutationUpdateClientsAssociatedArgs = {
  data: ClientsAssociatedUpdateInput;
  where: ClientsAssociatedWhereUniqueInput;
};


export type MutationUpdateClientsAssociatedsArgs = {
  data: Array<ClientsAssociatedUpdateArgs>;
};


export type MutationUpdateCoachArgs = {
  data: CoachUpdateInput;
  where: CoachWhereUniqueInput;
};


export type MutationUpdateCoachesArgs = {
  data: Array<CoachUpdateArgs>;
};


export type MutationUpdateCreditArgs = {
  data: CreditUpdateInput;
  where: CreditWhereUniqueInput;
};


export type MutationUpdateCreditsArgs = {
  data: Array<CreditUpdateArgs>;
};


export type MutationUpdateDeviceArgs = {
  data: DeviceUpdateInput;
  where: DeviceWhereUniqueInput;
};


export type MutationUpdateDevicesArgs = {
  data: Array<DeviceUpdateArgs>;
};


export type MutationUpdateLanguageArgs = {
  data: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};


export type MutationUpdateLanguagesArgs = {
  data: Array<LanguageUpdateArgs>;
};


export type MutationUpdatePaymentArgs = {
  data: PaymentUpdateInput;
  where: PaymentWhereUniqueInput;
};


export type MutationUpdatePaymentsArgs = {
  data: Array<PaymentUpdateArgs>;
};


export type MutationUpdatePaymentsProviderArgs = {
  data: PaymentsProviderUpdateInput;
  where: PaymentsProviderWhereUniqueInput;
};


export type MutationUpdatePaymentsProvidersArgs = {
  data: Array<PaymentsProviderUpdateArgs>;
};


export type MutationUpdatePlanArgs = {
  data: PlanUpdateInput;
  where: PlanWhereUniqueInput;
};


export type MutationUpdatePlansArgs = {
  data: Array<PlanUpdateArgs>;
};


export type MutationUpdateRepeatSessionArgs = {
  data: RepeatSessionUpdateInput;
  where: RepeatSessionWhereUniqueInput;
};


export type MutationUpdateRepeatSessionsArgs = {
  data: Array<RepeatSessionUpdateArgs>;
};


export type MutationUpdateSessionArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpdateSessionCategoriesArgs = {
  data: Array<SessionCategoryUpdateArgs>;
};


export type MutationUpdateSessionCategoryArgs = {
  data: SessionCategoryUpdateInput;
  where: SessionCategoryWhereUniqueInput;
};


export type MutationUpdateSessionSubscriptionArgs = {
  data: SessionSubscriptionUpdateInput;
  where: SessionSubscriptionWhereUniqueInput;
};


export type MutationUpdateSessionSubscriptionsArgs = {
  data: Array<SessionSubscriptionUpdateArgs>;
};


export type MutationUpdateSessionsArgs = {
  data: Array<SessionUpdateArgs>;
};


export type MutationUpdateSpaceArgs = {
  data: SpaceUpdateInput;
  where: SpaceWhereUniqueInput;
};


export type MutationUpdateSpaceByServiceArgs = {
  data: SpaceUpdateInput;
  token: Scalars['String']['input'];
  where: SpaceWhereUniqueInput;
};


export type MutationUpdateSpaceRequestArgs = {
  data: SpaceRequestUpdateInput;
  where: SpaceRequestWhereUniqueInput;
};


export type MutationUpdateSpaceRequestsArgs = {
  data: Array<SpaceRequestUpdateArgs>;
};


export type MutationUpdateSpacesArgs = {
  data: Array<SpaceUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserBackofficeArgs = {
  data: UserBackofficeUpdateInput;
  where: UserBackofficeWhereUniqueInput;
};


export type MutationUpdateUserBackofficesArgs = {
  data: Array<UserBackofficeUpdateArgs>;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};


export type MutationVerifyExistEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationVerifyExistUserInDbArgs = {
  userId: Scalars['ID']['input'];
};


export type MutationVerifyStripeAccountArgs = {
  accountId: Scalars['String']['input'];
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NewSubscriptionInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  subscriptionName?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type PasswordFilter = {
  isSet: Scalars['Boolean']['input'];
};

export type PasswordState = {
  __typename?: 'PasswordState';
  isSet: Scalars['Boolean']['output'];
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  credit?: Maybe<Credit>;
  id: Scalars['ID']['output'];
  method?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  paymentRefId?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  requestLog?: Maybe<Scalars['JSON']['output']>;
  responseLog?: Maybe<Scalars['JSON']['output']>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type PaymentCreateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  credit?: InputMaybe<CreditRelateToOneForCreateInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentRefId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requestLog?: InputMaybe<Scalars['JSON']['input']>;
  responseLog?: InputMaybe<Scalars['JSON']['input']>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type PaymentManyRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card: PaymentMethodCard;
  created: Scalars['Int']['output'];
  customer: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  livemode: Scalars['Boolean']['output'];
  redaction?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type PaymentMethodCard = {
  __typename?: 'PaymentMethodCard';
  brand: Scalars['String']['output'];
  checks: CardChecks;
  country: Scalars['String']['output'];
  exp_month: Scalars['Int']['output'];
  exp_year: Scalars['Int']['output'];
  fingerprint: Scalars['String']['output'];
  funding: Scalars['String']['output'];
  generated_from?: Maybe<Scalars['String']['output']>;
  last4: Scalars['String']['output'];
  networks: CardNetworks;
  three_d_secure_usage: ThreeDSecureUsage;
  wallet?: Maybe<Scalars['String']['output']>;
};

export type PaymentOrderByInput = {
  amount?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  method?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  note?: InputMaybe<OrderDirection>;
  paymentMethodId?: InputMaybe<OrderDirection>;
  paymentRefId?: InputMaybe<OrderDirection>;
  quantity?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type PaymentRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  create?: InputMaybe<Array<PaymentCreateInput>>;
};

export type PaymentRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  create?: InputMaybe<Array<PaymentCreateInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
};

export type PaymentRelateToOneForCreateInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  create?: InputMaybe<PaymentCreateInput>;
};

export type PaymentRelateToOneForUpdateInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  create?: InputMaybe<PaymentCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PaymentUpdateArgs = {
  data: PaymentUpdateInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  credit?: InputMaybe<CreditRelateToOneForUpdateInput>;
  method?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  paymentRefId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  requestLog?: InputMaybe<Scalars['JSON']['input']>;
  responseLog?: InputMaybe<Scalars['JSON']['input']>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  credit?: InputMaybe<CreditWhereInput>;
  id?: InputMaybe<IdFilter>;
  method?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  note?: InputMaybe<StringFilter>;
  paymentMethodId?: InputMaybe<StringFilter>;
  paymentRefId?: InputMaybe<StringFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type PaymentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PaymentsProvider = {
  __typename?: 'PaymentsProvider';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};

export type PaymentsProviderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type PaymentsProviderManyRelationFilter = {
  every?: InputMaybe<PaymentsProviderWhereInput>;
  none?: InputMaybe<PaymentsProviderWhereInput>;
  some?: InputMaybe<PaymentsProviderWhereInput>;
};

export type PaymentsProviderOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  provider?: InputMaybe<OrderDirection>;
  referenceId?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type PaymentsProviderRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<PaymentsProviderWhereUniqueInput>>;
  create?: InputMaybe<Array<PaymentsProviderCreateInput>>;
};

export type PaymentsProviderRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<PaymentsProviderWhereUniqueInput>>;
  create?: InputMaybe<Array<PaymentsProviderCreateInput>>;
  disconnect?: InputMaybe<Array<PaymentsProviderWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentsProviderWhereUniqueInput>>;
};

export type PaymentsProviderUpdateArgs = {
  data: PaymentsProviderUpdateInput;
  where: PaymentsProviderWhereUniqueInput;
};

export type PaymentsProviderUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  provider?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type PaymentsProviderWhereInput = {
  AND?: InputMaybe<Array<PaymentsProviderWhereInput>>;
  NOT?: InputMaybe<Array<PaymentsProviderWhereInput>>;
  OR?: InputMaybe<Array<PaymentsProviderWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  provider?: InputMaybe<StringFilter>;
  referenceId?: InputMaybe<StringFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type PaymentsProviderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  categories?: Maybe<Array<SessionCategory>>;
  categoriesCount?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  credit?: Maybe<Array<Credit>>;
  creditCount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Decimal']['output']>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type PlanCategoriesArgs = {
  cursor?: InputMaybe<SessionCategoryWhereUniqueInput>;
  orderBy?: Array<SessionCategoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionCategoryWhereInput;
};


export type PlanCategoriesCountArgs = {
  where?: SessionCategoryWhereInput;
};


export type PlanCreditArgs = {
  cursor?: InputMaybe<CreditWhereUniqueInput>;
  orderBy?: Array<CreditOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CreditWhereInput;
};


export type PlanCreditCountArgs = {
  where?: CreditWhereInput;
};

export type PlanCreateInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForCreateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  credit?: InputMaybe<CreditRelateToManyForCreateInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type PlanManyRelationFilter = {
  every?: InputMaybe<PlanWhereInput>;
  none?: InputMaybe<PlanWhereInput>;
  some?: InputMaybe<PlanWhereInput>;
};

export type PlanOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  duration?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  points?: InputMaybe<OrderDirection>;
  price?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  summary?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type PlanRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<PlanWhereUniqueInput>>;
  create?: InputMaybe<Array<PlanCreateInput>>;
};

export type PlanRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<PlanWhereUniqueInput>>;
  create?: InputMaybe<Array<PlanCreateInput>>;
  disconnect?: InputMaybe<Array<PlanWhereUniqueInput>>;
  set?: InputMaybe<Array<PlanWhereUniqueInput>>;
};

export type PlanRelateToOneForCreateInput = {
  connect?: InputMaybe<PlanWhereUniqueInput>;
  create?: InputMaybe<PlanCreateInput>;
};

export type PlanRelateToOneForUpdateInput = {
  connect?: InputMaybe<PlanWhereUniqueInput>;
  create?: InputMaybe<PlanCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlanUpdateArgs = {
  data: PlanUpdateInput;
  where: PlanWhereUniqueInput;
};

export type PlanUpdateInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForUpdateInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  credit?: InputMaybe<CreditRelateToManyForUpdateInput>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  price?: InputMaybe<Scalars['Decimal']['input']>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type PlanWhereInput = {
  AND?: InputMaybe<Array<PlanWhereInput>>;
  NOT?: InputMaybe<Array<PlanWhereInput>>;
  OR?: InputMaybe<Array<PlanWhereInput>>;
  categories?: InputMaybe<SessionCategoryManyRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  credit?: InputMaybe<CreditManyRelationFilter>;
  duration?: InputMaybe<IntFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  points?: InputMaybe<IntFilter>;
  price?: InputMaybe<DecimalFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  summary?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type PlanWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProviderData = {
  __typename?: 'ProviderData';
  displayName: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  authenticatedItem?: Maybe<AuthenticatedItem>;
  badge?: Maybe<Badge>;
  badgeItem?: Maybe<BadgeItem>;
  badgeItems?: Maybe<Array<BadgeItem>>;
  badgeItemsCount?: Maybe<Scalars['Int']['output']>;
  badges?: Maybe<Array<Badge>>;
  badgesCount?: Maybe<Scalars['Int']['output']>;
  classOffered?: Maybe<ClassOffered>;
  classOfferedSchedule?: Maybe<ClassOfferedSchedule>;
  classOfferedSchedules?: Maybe<Array<ClassOfferedSchedule>>;
  classOfferedSchedulesCount?: Maybe<Scalars['Int']['output']>;
  classOffereds?: Maybe<Array<ClassOffered>>;
  classOfferedsCount?: Maybe<Scalars['Int']['output']>;
  clientsAssociated?: Maybe<ClientsAssociated>;
  clientsAssociateds?: Maybe<Array<ClientsAssociated>>;
  clientsAssociatedsCount?: Maybe<Scalars['Int']['output']>;
  coach?: Maybe<Coach>;
  coaches?: Maybe<Array<Coach>>;
  coachesCount?: Maybe<Scalars['Int']['output']>;
  credit?: Maybe<Credit>;
  credits?: Maybe<Array<Credit>>;
  creditsCount?: Maybe<Scalars['Int']['output']>;
  device?: Maybe<Device>;
  devices?: Maybe<Array<Device>>;
  devicesCount?: Maybe<Scalars['Int']['output']>;
  getPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  keystone: KeystoneMeta;
  language?: Maybe<Language>;
  languages?: Maybe<Array<Language>>;
  languagesCount?: Maybe<Scalars['Int']['output']>;
  leaderboardBySpace?: Maybe<Array<Maybe<Competitor>>>;
  payment?: Maybe<Payment>;
  payments?: Maybe<Array<Payment>>;
  paymentsCount?: Maybe<Scalars['Int']['output']>;
  paymentsProvider?: Maybe<PaymentsProvider>;
  paymentsProviders?: Maybe<Array<PaymentsProvider>>;
  paymentsProvidersCount?: Maybe<Scalars['Int']['output']>;
  ping: Scalars['Boolean']['output'];
  plan?: Maybe<Plan>;
  plans?: Maybe<Array<Plan>>;
  plansCount?: Maybe<Scalars['Int']['output']>;
  repeatSession?: Maybe<RepeatSession>;
  repeatSessions?: Maybe<Array<RepeatSession>>;
  repeatSessionsCount?: Maybe<Scalars['Int']['output']>;
  reportTotalClients: ReportTotalClients;
  reportTotalRevenue: ReportTotalRevenue;
  session?: Maybe<Session>;
  sessionCategories?: Maybe<Array<SessionCategory>>;
  sessionCategoriesCount?: Maybe<Scalars['Int']['output']>;
  sessionCategory?: Maybe<SessionCategory>;
  sessionSubscription?: Maybe<SessionSubscription>;
  sessionSubscriptionForDay?: Maybe<Array<Maybe<Session>>>;
  sessionSubscriptions?: Maybe<Array<SessionSubscription>>;
  sessionSubscriptionsCount?: Maybe<Scalars['Int']['output']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  sessionsListBackoffice?: Maybe<Array<Maybe<SessionByBackoffice>>>;
  space?: Maybe<Space>;
  spaceIdByService?: Maybe<Space>;
  spaceRequest?: Maybe<SpaceRequest>;
  spaceRequests?: Maybe<Array<SpaceRequest>>;
  spaceRequestsCount?: Maybe<Scalars['Int']['output']>;
  spaces?: Maybe<Array<Space>>;
  spacesByService?: Maybe<Array<Maybe<Space>>>;
  spacesCount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userBackoffice?: Maybe<UserBackoffice>;
  userBackoffices?: Maybe<Array<UserBackoffice>>;
  userBackofficesCount?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  verifyToken?: Maybe<VerifyTokenResult>;
};


export type QueryBadgeArgs = {
  where: BadgeWhereUniqueInput;
};


export type QueryBadgeItemArgs = {
  where: BadgeItemWhereUniqueInput;
};


export type QueryBadgeItemsArgs = {
  cursor?: InputMaybe<BadgeItemWhereUniqueInput>;
  orderBy?: Array<BadgeItemOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BadgeItemWhereInput;
};


export type QueryBadgeItemsCountArgs = {
  where?: BadgeItemWhereInput;
};


export type QueryBadgesArgs = {
  cursor?: InputMaybe<BadgeWhereUniqueInput>;
  orderBy?: Array<BadgeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BadgeWhereInput;
};


export type QueryBadgesCountArgs = {
  where?: BadgeWhereInput;
};


export type QueryClassOfferedArgs = {
  where: ClassOfferedWhereUniqueInput;
};


export type QueryClassOfferedScheduleArgs = {
  where: ClassOfferedScheduleWhereUniqueInput;
};


export type QueryClassOfferedSchedulesArgs = {
  cursor?: InputMaybe<ClassOfferedScheduleWhereUniqueInput>;
  orderBy?: Array<ClassOfferedScheduleOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClassOfferedScheduleWhereInput;
};


export type QueryClassOfferedSchedulesCountArgs = {
  where?: ClassOfferedScheduleWhereInput;
};


export type QueryClassOfferedsArgs = {
  cursor?: InputMaybe<ClassOfferedWhereUniqueInput>;
  orderBy?: Array<ClassOfferedOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClassOfferedWhereInput;
};


export type QueryClassOfferedsCountArgs = {
  where?: ClassOfferedWhereInput;
};


export type QueryClientsAssociatedArgs = {
  where: ClientsAssociatedWhereUniqueInput;
};


export type QueryClientsAssociatedsArgs = {
  cursor?: InputMaybe<ClientsAssociatedWhereUniqueInput>;
  orderBy?: Array<ClientsAssociatedOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClientsAssociatedWhereInput;
};


export type QueryClientsAssociatedsCountArgs = {
  where?: ClientsAssociatedWhereInput;
};


export type QueryCoachArgs = {
  where: CoachWhereUniqueInput;
};


export type QueryCoachesArgs = {
  cursor?: InputMaybe<CoachWhereUniqueInput>;
  orderBy?: Array<CoachOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CoachWhereInput;
};


export type QueryCoachesCountArgs = {
  where?: CoachWhereInput;
};


export type QueryCreditArgs = {
  where: CreditWhereUniqueInput;
};


export type QueryCreditsArgs = {
  cursor?: InputMaybe<CreditWhereUniqueInput>;
  orderBy?: Array<CreditOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CreditWhereInput;
};


export type QueryCreditsCountArgs = {
  where?: CreditWhereInput;
};


export type QueryDeviceArgs = {
  where: DeviceWhereUniqueInput;
};


export type QueryDevicesArgs = {
  cursor?: InputMaybe<DeviceWhereUniqueInput>;
  orderBy?: Array<DeviceOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DeviceWhereInput;
};


export type QueryDevicesCountArgs = {
  where?: DeviceWhereInput;
};


export type QueryLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type QueryLanguagesArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  orderBy?: Array<LanguageOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: LanguageWhereInput;
};


export type QueryLanguagesCountArgs = {
  where?: LanguageWhereInput;
};


export type QueryLeaderboardBySpaceArgs = {
  spaceId: Scalars['ID']['input'];
  time: FilterTimeEnum;
};


export type QueryPaymentArgs = {
  where: PaymentWhereUniqueInput;
};


export type QueryPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  orderBy?: Array<PaymentOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PaymentWhereInput;
};


export type QueryPaymentsCountArgs = {
  where?: PaymentWhereInput;
};


export type QueryPaymentsProviderArgs = {
  where: PaymentsProviderWhereUniqueInput;
};


export type QueryPaymentsProvidersArgs = {
  cursor?: InputMaybe<PaymentsProviderWhereUniqueInput>;
  orderBy?: Array<PaymentsProviderOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PaymentsProviderWhereInput;
};


export type QueryPaymentsProvidersCountArgs = {
  where?: PaymentsProviderWhereInput;
};


export type QueryPlanArgs = {
  where: PlanWhereUniqueInput;
};


export type QueryPlansArgs = {
  cursor?: InputMaybe<PlanWhereUniqueInput>;
  orderBy?: Array<PlanOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PlanWhereInput;
};


export type QueryPlansCountArgs = {
  where?: PlanWhereInput;
};


export type QueryRepeatSessionArgs = {
  where: RepeatSessionWhereUniqueInput;
};


export type QueryRepeatSessionsArgs = {
  cursor?: InputMaybe<RepeatSessionWhereUniqueInput>;
  orderBy?: Array<RepeatSessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RepeatSessionWhereInput;
};


export type QueryRepeatSessionsCountArgs = {
  where?: RepeatSessionWhereInput;
};


export type QueryReportTotalClientsArgs = {
  data?: InputMaybe<CreateReportTotals>;
};


export type QueryReportTotalRevenueArgs = {
  data?: InputMaybe<CreateReportTotals>;
};


export type QuerySessionArgs = {
  where: SessionWhereUniqueInput;
};


export type QuerySessionCategoriesArgs = {
  cursor?: InputMaybe<SessionCategoryWhereUniqueInput>;
  orderBy?: Array<SessionCategoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionCategoryWhereInput;
};


export type QuerySessionCategoriesCountArgs = {
  where?: SessionCategoryWhereInput;
};


export type QuerySessionCategoryArgs = {
  where: SessionCategoryWhereUniqueInput;
};


export type QuerySessionSubscriptionArgs = {
  where: SessionSubscriptionWhereUniqueInput;
};


export type QuerySessionSubscriptionForDayArgs = {
  day: Scalars['String']['input'];
  spaceId: Scalars['ID']['input'];
};


export type QuerySessionSubscriptionsArgs = {
  cursor?: InputMaybe<SessionSubscriptionWhereUniqueInput>;
  orderBy?: Array<SessionSubscriptionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionSubscriptionWhereInput;
};


export type QuerySessionSubscriptionsCountArgs = {
  where?: SessionSubscriptionWhereInput;
};


export type QuerySessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionWhereInput;
};


export type QuerySessionsCountArgs = {
  where?: SessionWhereInput;
};


export type QuerySessionsListBackofficeArgs = {
  day: Scalars['String']['input'];
  spaceId: Scalars['ID']['input'];
  time: FilterTimeEnum;
};


export type QuerySpaceArgs = {
  where: SpaceWhereUniqueInput;
};


export type QuerySpaceIdByServiceArgs = {
  token: Scalars['String']['input'];
  where: SpaceWhereUniqueInput;
};


export type QuerySpaceRequestArgs = {
  where: SpaceRequestWhereUniqueInput;
};


export type QuerySpaceRequestsArgs = {
  cursor?: InputMaybe<SpaceRequestWhereUniqueInput>;
  orderBy?: Array<SpaceRequestOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SpaceRequestWhereInput;
};


export type QuerySpaceRequestsCountArgs = {
  where?: SpaceRequestWhereInput;
};


export type QuerySpacesArgs = {
  cursor?: InputMaybe<SpaceWhereUniqueInput>;
  orderBy?: Array<SpaceOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SpaceWhereInput;
};


export type QuerySpacesByServiceArgs = {
  token: Scalars['String']['input'];
  where: SpaceWhereInput;
};


export type QuerySpacesCountArgs = {
  where?: SpaceWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUserBackofficeArgs = {
  where: UserBackofficeWhereUniqueInput;
};


export type QueryUserBackofficesArgs = {
  cursor?: InputMaybe<UserBackofficeWhereUniqueInput>;
  orderBy?: Array<UserBackofficeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserBackofficeWhereInput;
};


export type QueryUserBackofficesCountArgs = {
  where?: UserBackofficeWhereInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};


export type QueryVerifyTokenArgs = {
  token: Scalars['String']['input'];
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RepeatSession = {
  __typename?: 'RepeatSession';
  categories?: Maybe<Array<SessionCategory>>;
  categoriesCount?: Maybe<Scalars['Int']['output']>;
  coach?: Maybe<Coach>;
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  daysRepeat?: Maybe<Array<RepeatSessionDaysRepeatType>>;
  description?: Maybe<Scalars['String']['output']>;
  finishType?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  finishedRepeatAt?: Maybe<Scalars['DateTime']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['Int']['output']>;
  limitQuote?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  space?: Maybe<Space>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type RepeatSessionCategoriesArgs = {
  cursor?: InputMaybe<SessionCategoryWhereUniqueInput>;
  orderBy?: Array<SessionCategoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionCategoryWhereInput;
};


export type RepeatSessionCategoriesCountArgs = {
  where?: SessionCategoryWhereInput;
};


export type RepeatSessionSessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionWhereInput;
};


export type RepeatSessionSessionsCountArgs = {
  where?: SessionWhereInput;
};

export type RepeatSessionCreateInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForCreateInput>;
  coach?: InputMaybe<CoachRelateToOneForCreateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  daysRepeat?: InputMaybe<Array<RepeatSessionDaysRepeatType>>;
  description?: InputMaybe<Scalars['String']['input']>;
  finishType?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishedRepeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  limitQuote?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionRelateToManyForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export enum RepeatSessionDaysRepeatType {
  Friday = 'friday',
  Monday = 'monday',
  Saturday = 'saturday',
  Sunday = 'sunday',
  Thursday = 'thursday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday'
}

export type RepeatSessionManyRelationFilter = {
  every?: InputMaybe<RepeatSessionWhereInput>;
  none?: InputMaybe<RepeatSessionWhereInput>;
  some?: InputMaybe<RepeatSessionWhereInput>;
};

export type RepeatSessionOrderByInput = {
  color?: InputMaybe<OrderDirection>;
  cost?: InputMaybe<OrderDirection>;
  count?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  finishType?: InputMaybe<OrderDirection>;
  finishedAt?: InputMaybe<OrderDirection>;
  finishedRepeatAt?: InputMaybe<OrderDirection>;
  frequency?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  interval?: InputMaybe<OrderDirection>;
  limitQuote?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  startedAt?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type RepeatSessionRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<RepeatSessionWhereUniqueInput>>;
  create?: InputMaybe<Array<RepeatSessionCreateInput>>;
};

export type RepeatSessionRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<RepeatSessionWhereUniqueInput>>;
  create?: InputMaybe<Array<RepeatSessionCreateInput>>;
  disconnect?: InputMaybe<Array<RepeatSessionWhereUniqueInput>>;
  set?: InputMaybe<Array<RepeatSessionWhereUniqueInput>>;
};

export type RepeatSessionRelateToOneForCreateInput = {
  connect?: InputMaybe<RepeatSessionWhereUniqueInput>;
  create?: InputMaybe<RepeatSessionCreateInput>;
};

export type RepeatSessionRelateToOneForUpdateInput = {
  connect?: InputMaybe<RepeatSessionWhereUniqueInput>;
  create?: InputMaybe<RepeatSessionCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RepeatSessionUpdateArgs = {
  data: RepeatSessionUpdateInput;
  where: RepeatSessionWhereUniqueInput;
};

export type RepeatSessionUpdateInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForUpdateInput>;
  coach?: InputMaybe<CoachRelateToOneForUpdateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  count?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  daysRepeat?: InputMaybe<Array<RepeatSessionDaysRepeatType>>;
  description?: InputMaybe<Scalars['String']['input']>;
  finishType?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  finishedRepeatAt?: InputMaybe<Scalars['DateTime']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  limitQuote?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionRelateToManyForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type RepeatSessionWhereInput = {
  AND?: InputMaybe<Array<RepeatSessionWhereInput>>;
  NOT?: InputMaybe<Array<RepeatSessionWhereInput>>;
  OR?: InputMaybe<Array<RepeatSessionWhereInput>>;
  categories?: InputMaybe<SessionCategoryManyRelationFilter>;
  coach?: InputMaybe<CoachWhereInput>;
  color?: InputMaybe<StringFilter>;
  cost?: InputMaybe<IntFilter>;
  count?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<StringFilter>;
  finishType?: InputMaybe<StringNullableFilter>;
  finishedAt?: InputMaybe<DateTimeFilter>;
  finishedRepeatAt?: InputMaybe<DateTimeNullableFilter>;
  frequency?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IdFilter>;
  interval?: InputMaybe<IntFilter>;
  limitQuote?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  sessions?: InputMaybe<SessionManyRelationFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  startedAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type RepeatSessionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportTotalClients = {
  __typename?: 'ReportTotalClients';
  active: Scalars['Int']['output'];
  inactive: Scalars['Int']['output'];
  totals: TotalsValue;
};

export type ReportTotalRevenue = {
  __typename?: 'ReportTotalRevenue';
  beforeTotalByClient: Scalars['Float']['output'];
  currentPayments: Array<Payment>;
  currentTotalByClient: Scalars['Float']['output'];
  revenueByClient: TotalsValue;
  totals: TotalsValue;
};

export enum SendUserNotificationEnum {
  All = 'ALL',
  Selection = 'SELECTION'
}

export enum SendUserNotificationFilterEnum {
  ActiveUsers = 'ACTIVE_USERS',
  InactiveUsers = 'INACTIVE_USERS'
}

export type SendUserNotificationTemplateInput = {
  connect?: InputMaybe<Array<Scalars['ID']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  filter?: InputMaybe<SendUserNotificationFilterEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  template: SendUserNotificationEnum;
};

export type Session = {
  __typename?: 'Session';
  categories?: Maybe<Array<SessionCategory>>;
  categoriesCount?: Maybe<Scalars['Int']['output']>;
  coach?: Maybe<Coach>;
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isBacklog?: Maybe<Scalars['Boolean']['output']>;
  limitQuote?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rootEvent?: Maybe<RepeatSession>;
  space?: Maybe<Space>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<SessionSubscription>>;
  subscriptionsCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type SessionCategoriesArgs = {
  cursor?: InputMaybe<SessionCategoryWhereUniqueInput>;
  orderBy?: Array<SessionCategoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionCategoryWhereInput;
};


export type SessionCategoriesCountArgs = {
  where?: SessionCategoryWhereInput;
};


export type SessionSubscriptionsArgs = {
  cursor?: InputMaybe<SessionSubscriptionWhereUniqueInput>;
  orderBy?: Array<SessionSubscriptionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionSubscriptionWhereInput;
};


export type SessionSubscriptionsCountArgs = {
  where?: SessionSubscriptionWhereInput;
};

export type SessionByBackoffice = {
  __typename?: 'SessionByBackoffice';
  categories?: Maybe<Array<Maybe<SessionCategory>>>;
  coach?: Maybe<SessionByBackofficeCoach>;
  color?: Maybe<Scalars['String']['output']>;
  cost?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isBacklog?: Maybe<Scalars['Boolean']['output']>;
  limitQuote?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rootEvent?: Maybe<SessionByBackofficeRootEvent>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<Maybe<SessionSubscriptionBackOffice>>>;
  subscriptionsCount?: Maybe<Scalars['Int']['output']>;
};

export type SessionByBackofficeCoach = {
  __typename?: 'SessionByBackofficeCoach';
  avatar: SessionByBackofficeFile;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SessionByBackofficeFile = {
  __typename?: 'SessionByBackofficeFile';
  id?: Maybe<Scalars['ID']['output']>;
  url: Scalars['String']['output'];
};

export type SessionByBackofficeRootEvent = {
  __typename?: 'SessionByBackofficeRootEvent';
  cost?: Maybe<Scalars['Int']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  daysRepeat?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  finishType?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  finishedRepeatAt?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['Int']['output']>;
  limitQuote?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};

export type SessionCategory = {
  __typename?: 'SessionCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<Plan>>;
  plansCount?: Maybe<Scalars['Int']['output']>;
  root_sessions?: Maybe<Array<RepeatSession>>;
  root_sessionsCount?: Maybe<Scalars['Int']['output']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type SessionCategoryPlansArgs = {
  cursor?: InputMaybe<PlanWhereUniqueInput>;
  orderBy?: Array<PlanOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PlanWhereInput;
};


export type SessionCategoryPlansCountArgs = {
  where?: PlanWhereInput;
};


export type SessionCategoryRoot_SessionsArgs = {
  cursor?: InputMaybe<RepeatSessionWhereUniqueInput>;
  orderBy?: Array<RepeatSessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RepeatSessionWhereInput;
};


export type SessionCategoryRoot_SessionsCountArgs = {
  where?: RepeatSessionWhereInput;
};


export type SessionCategorySessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionWhereInput;
};


export type SessionCategorySessionsCountArgs = {
  where?: SessionWhereInput;
};

export type SessionCategoryCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  plans?: InputMaybe<PlanRelateToManyForCreateInput>;
  root_sessions?: InputMaybe<RepeatSessionRelateToManyForCreateInput>;
  sessions?: InputMaybe<SessionRelateToManyForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type SessionCategoryManyRelationFilter = {
  every?: InputMaybe<SessionCategoryWhereInput>;
  none?: InputMaybe<SessionCategoryWhereInput>;
  some?: InputMaybe<SessionCategoryWhereInput>;
};

export type SessionCategoryOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type SessionCategoryRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<SessionCategoryWhereUniqueInput>>;
  create?: InputMaybe<Array<SessionCategoryCreateInput>>;
};

export type SessionCategoryRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<SessionCategoryWhereUniqueInput>>;
  create?: InputMaybe<Array<SessionCategoryCreateInput>>;
  disconnect?: InputMaybe<Array<SessionCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionCategoryWhereUniqueInput>>;
};

export type SessionCategoryUpdateArgs = {
  data: SessionCategoryUpdateInput;
  where: SessionCategoryWhereUniqueInput;
};

export type SessionCategoryUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  plans?: InputMaybe<PlanRelateToManyForUpdateInput>;
  root_sessions?: InputMaybe<RepeatSessionRelateToManyForUpdateInput>;
  sessions?: InputMaybe<SessionRelateToManyForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type SessionCategoryWhereInput = {
  AND?: InputMaybe<Array<SessionCategoryWhereInput>>;
  NOT?: InputMaybe<Array<SessionCategoryWhereInput>>;
  OR?: InputMaybe<Array<SessionCategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  plans?: InputMaybe<PlanManyRelationFilter>;
  root_sessions?: InputMaybe<RepeatSessionManyRelationFilter>;
  sessions?: InputMaybe<SessionManyRelationFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type SessionCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SessionCreateInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForCreateInput>;
  coach?: InputMaybe<CoachRelateToOneForCreateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  limitQuote?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rootEvent?: InputMaybe<RepeatSessionRelateToOneForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type SessionManyRelationFilter = {
  every?: InputMaybe<SessionWhereInput>;
  none?: InputMaybe<SessionWhereInput>;
  some?: InputMaybe<SessionWhereInput>;
};

export type SessionOrderByInput = {
  color?: InputMaybe<OrderDirection>;
  cost?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  finishedAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  limitQuote?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  startedAt?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type SessionRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  create?: InputMaybe<Array<SessionCreateInput>>;
};

export type SessionRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  create?: InputMaybe<Array<SessionCreateInput>>;
  disconnect?: InputMaybe<Array<SessionWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionWhereUniqueInput>>;
};

export type SessionRelateToOneForCreateInput = {
  connect?: InputMaybe<SessionWhereUniqueInput>;
  create?: InputMaybe<SessionCreateInput>;
};

export type SessionRelateToOneForUpdateInput = {
  connect?: InputMaybe<SessionWhereUniqueInput>;
  create?: InputMaybe<SessionCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SessionSubscription = {
  __typename?: 'SessionSubscription';
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  credit?: Maybe<Credit>;
  creditCost?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  sessionForSubscribe?: Maybe<Session>;
  space?: Maybe<Space>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type SessionSubscriptionBackOffice = {
  __typename?: 'SessionSubscriptionBackOffice';
  confirmedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creditCost?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserSubscription>;
};

export type SessionSubscriptionCreateInput = {
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  credit?: InputMaybe<CreditRelateToOneForCreateInput>;
  creditCost?: InputMaybe<Scalars['Int']['input']>;
  sessionForSubscribe?: InputMaybe<SessionRelateToOneForCreateInput>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type SessionSubscriptionManyRelationFilter = {
  every?: InputMaybe<SessionSubscriptionWhereInput>;
  none?: InputMaybe<SessionSubscriptionWhereInput>;
  some?: InputMaybe<SessionSubscriptionWhereInput>;
};

export type SessionSubscriptionOrderByInput = {
  confirmedAt?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  creditCost?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type SessionSubscriptionRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<SessionSubscriptionWhereUniqueInput>>;
  create?: InputMaybe<Array<SessionSubscriptionCreateInput>>;
};

export type SessionSubscriptionRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<SessionSubscriptionWhereUniqueInput>>;
  create?: InputMaybe<Array<SessionSubscriptionCreateInput>>;
  disconnect?: InputMaybe<Array<SessionSubscriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<SessionSubscriptionWhereUniqueInput>>;
};

export type SessionSubscriptionUpdateArgs = {
  data: SessionSubscriptionUpdateInput;
  where: SessionSubscriptionWhereUniqueInput;
};

export type SessionSubscriptionUpdateInput = {
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  credit?: InputMaybe<CreditRelateToOneForUpdateInput>;
  creditCost?: InputMaybe<Scalars['Int']['input']>;
  sessionForSubscribe?: InputMaybe<SessionRelateToOneForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type SessionSubscriptionWhereInput = {
  AND?: InputMaybe<Array<SessionSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<SessionSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<SessionSubscriptionWhereInput>>;
  confirmedAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  credit?: InputMaybe<CreditWhereInput>;
  creditCost?: InputMaybe<IntFilter>;
  id?: InputMaybe<IdFilter>;
  sessionForSubscribe?: InputMaybe<SessionWhereInput>;
  space?: InputMaybe<SpaceWhereInput>;
  status?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type SessionSubscriptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SessionUpdateArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};

export type SessionUpdateInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForUpdateInput>;
  coach?: InputMaybe<CoachRelateToOneForUpdateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  limitQuote?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rootEvent?: InputMaybe<RepeatSessionRelateToOneForUpdateInput>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForUpdateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type SessionWhereInput = {
  AND?: InputMaybe<Array<SessionWhereInput>>;
  NOT?: InputMaybe<Array<SessionWhereInput>>;
  OR?: InputMaybe<Array<SessionWhereInput>>;
  categories?: InputMaybe<SessionCategoryManyRelationFilter>;
  coach?: InputMaybe<CoachWhereInput>;
  color?: InputMaybe<StringFilter>;
  cost?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<StringFilter>;
  finishedAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  limitQuote?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  rootEvent?: InputMaybe<RepeatSessionWhereInput>;
  space?: InputMaybe<SpaceWhereInput>;
  startedAt?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<StringNullableFilter>;
  subscriptions?: InputMaybe<SessionSubscriptionManyRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type SessionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Space = {
  __typename?: 'Space';
  address?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  amenities?: Maybe<Array<Scalars['String']['output']>>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  badges?: Maybe<Array<Badge>>;
  badgesCount?: Maybe<Scalars['Int']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingRef?: Maybe<Scalars['String']['output']>;
  billingScheduleId?: Maybe<Scalars['String']['output']>;
  classOffered?: Maybe<Array<ClassOffered>>;
  classOfferedCount?: Maybe<Scalars['Int']['output']>;
  clients?: Maybe<Array<ClientsAssociated>>;
  clientsCount?: Maybe<Scalars['Int']['output']>;
  coaches?: Maybe<Array<Coach>>;
  coachesCount?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  credits?: Maybe<Array<Credit>>;
  creditsCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gallery1?: Maybe<ImageFieldOutput>;
  gallery2?: Maybe<ImageFieldOutput>;
  gallery3?: Maybe<ImageFieldOutput>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  navBarColor?: Maybe<Scalars['String']['output']>;
  navBarTextColor?: Maybe<Scalars['String']['output']>;
  paymentLink?: Maybe<Scalars['String']['output']>;
  payments?: Maybe<Array<Payment>>;
  paymentsCount?: Maybe<Scalars['Int']['output']>;
  paymentsProvider?: Maybe<Array<PaymentsProvider>>;
  paymentsProviderCount?: Maybe<Scalars['Int']['output']>;
  phoneCountryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<Plan>>;
  plansCount?: Maybe<Scalars['Int']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  sessions?: Maybe<Array<Session>>;
  sessionsCount?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<SessionSubscription>>;
  subscriptionsCount?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  textPrimaryColor?: Maybe<Scalars['String']['output']>;
  textSecondaryColor?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<ImageFieldOutput>;
  trialEndAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  usersWithAccess?: Maybe<Array<UserBackoffice>>;
  usersWithAccessCount?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type SpaceBadgesArgs = {
  cursor?: InputMaybe<BadgeWhereUniqueInput>;
  orderBy?: Array<BadgeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: BadgeWhereInput;
};


export type SpaceBadgesCountArgs = {
  where?: BadgeWhereInput;
};


export type SpaceClassOfferedArgs = {
  cursor?: InputMaybe<ClassOfferedWhereUniqueInput>;
  orderBy?: Array<ClassOfferedOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClassOfferedWhereInput;
};


export type SpaceClassOfferedCountArgs = {
  where?: ClassOfferedWhereInput;
};


export type SpaceClientsArgs = {
  cursor?: InputMaybe<ClientsAssociatedWhereUniqueInput>;
  orderBy?: Array<ClientsAssociatedOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClientsAssociatedWhereInput;
};


export type SpaceClientsCountArgs = {
  where?: ClientsAssociatedWhereInput;
};


export type SpaceCoachesArgs = {
  cursor?: InputMaybe<CoachWhereUniqueInput>;
  orderBy?: Array<CoachOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CoachWhereInput;
};


export type SpaceCoachesCountArgs = {
  where?: CoachWhereInput;
};


export type SpaceCreditsArgs = {
  cursor?: InputMaybe<CreditWhereUniqueInput>;
  orderBy?: Array<CreditOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CreditWhereInput;
};


export type SpaceCreditsCountArgs = {
  where?: CreditWhereInput;
};


export type SpacePaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  orderBy?: Array<PaymentOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PaymentWhereInput;
};


export type SpacePaymentsCountArgs = {
  where?: PaymentWhereInput;
};


export type SpacePaymentsProviderArgs = {
  cursor?: InputMaybe<PaymentsProviderWhereUniqueInput>;
  orderBy?: Array<PaymentsProviderOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PaymentsProviderWhereInput;
};


export type SpacePaymentsProviderCountArgs = {
  where?: PaymentsProviderWhereInput;
};


export type SpacePlansArgs = {
  cursor?: InputMaybe<PlanWhereUniqueInput>;
  orderBy?: Array<PlanOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PlanWhereInput;
};


export type SpacePlansCountArgs = {
  where?: PlanWhereInput;
};


export type SpaceSessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: Array<SessionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionWhereInput;
};


export type SpaceSessionsCountArgs = {
  where?: SessionWhereInput;
};


export type SpaceSubscriptionsArgs = {
  cursor?: InputMaybe<SessionSubscriptionWhereUniqueInput>;
  orderBy?: Array<SessionSubscriptionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionSubscriptionWhereInput;
};


export type SpaceSubscriptionsCountArgs = {
  where?: SessionSubscriptionWhereInput;
};


export type SpaceUsersWithAccessArgs = {
  cursor?: InputMaybe<UserBackofficeWhereUniqueInput>;
  orderBy?: Array<UserBackofficeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserBackofficeWhereInput;
};


export type SpaceUsersWithAccessCountArgs = {
  where?: UserBackofficeWhereInput;
};

export type SpaceCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<Scalars['String']['input']>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  badges?: InputMaybe<BadgeRelateToManyForCreateInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingRef?: InputMaybe<Scalars['String']['input']>;
  billingScheduleId?: InputMaybe<Scalars['String']['input']>;
  classOffered?: InputMaybe<ClassOfferedRelateToManyForCreateInput>;
  clients?: InputMaybe<ClientsAssociatedRelateToManyForCreateInput>;
  coaches?: InputMaybe<CoachRelateToManyForCreateInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  credits?: InputMaybe<CreditRelateToManyForCreateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  gallery1?: InputMaybe<ImageFieldInput>;
  gallery2?: InputMaybe<ImageFieldInput>;
  gallery3?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  navBarColor?: InputMaybe<Scalars['String']['input']>;
  navBarTextColor?: InputMaybe<Scalars['String']['input']>;
  paymentLink?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentRelateToManyForCreateInput>;
  paymentsProvider?: InputMaybe<PaymentsProviderRelateToManyForCreateInput>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  plans?: InputMaybe<PlanRelateToManyForCreateInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionRelateToManyForCreateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForCreateInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  textPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  textSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<ImageFieldInput>;
  trialEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  usersWithAccess?: InputMaybe<UserBackofficeRelateToManyForCreateInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SpaceOrderByInput = {
  address?: InputMaybe<OrderDirection>;
  address2?: InputMaybe<OrderDirection>;
  backgroundColor?: InputMaybe<OrderDirection>;
  billingEmail?: InputMaybe<OrderDirection>;
  billingRef?: InputMaybe<OrderDirection>;
  billingScheduleId?: InputMaybe<OrderDirection>;
  country?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  navBarColor?: InputMaybe<OrderDirection>;
  navBarTextColor?: InputMaybe<OrderDirection>;
  paymentLink?: InputMaybe<OrderDirection>;
  phoneCountryCode?: InputMaybe<OrderDirection>;
  phoneNumber?: InputMaybe<OrderDirection>;
  plan?: InputMaybe<OrderDirection>;
  primaryColor?: InputMaybe<OrderDirection>;
  secondaryColor?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  summary?: InputMaybe<OrderDirection>;
  textPrimaryColor?: InputMaybe<OrderDirection>;
  textSecondaryColor?: InputMaybe<OrderDirection>;
  trialEndAt?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
  website?: InputMaybe<OrderDirection>;
};

export type SpaceRelateToOneForCreateInput = {
  connect?: InputMaybe<SpaceWhereUniqueInput>;
  create?: InputMaybe<SpaceCreateInput>;
};

export type SpaceRelateToOneForUpdateInput = {
  connect?: InputMaybe<SpaceWhereUniqueInput>;
  create?: InputMaybe<SpaceCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpaceRequest = {
  __typename?: 'SpaceRequest';
  address?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user_email?: Maybe<Scalars['String']['output']>;
  user_name?: Maybe<Scalars['String']['output']>;
  user_phoneCountryCode?: Maybe<Scalars['String']['output']>;
  user_phoneNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type SpaceRequestCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  user_phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  user_phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SpaceRequestOrderByInput = {
  address?: InputMaybe<OrderDirection>;
  country?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  lang?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  plan?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  summary?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
  user_email?: InputMaybe<OrderDirection>;
  user_name?: InputMaybe<OrderDirection>;
  user_phoneCountryCode?: InputMaybe<OrderDirection>;
  user_phoneNumber?: InputMaybe<OrderDirection>;
  website?: InputMaybe<OrderDirection>;
};

export type SpaceRequestUpdateArgs = {
  data: SpaceRequestUpdateInput;
  where: SpaceRequestWhereUniqueInput;
};

export type SpaceRequestUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user_email?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  user_phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  user_phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SpaceRequestWhereInput = {
  AND?: InputMaybe<Array<SpaceRequestWhereInput>>;
  NOT?: InputMaybe<Array<SpaceRequestWhereInput>>;
  OR?: InputMaybe<Array<SpaceRequestWhereInput>>;
  address?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  lang?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  plan?: InputMaybe<StringFilter>;
  status?: InputMaybe<StringNullableFilter>;
  summary?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user_email?: InputMaybe<StringFilter>;
  user_name?: InputMaybe<StringFilter>;
  user_phoneCountryCode?: InputMaybe<StringFilter>;
  user_phoneNumber?: InputMaybe<StringFilter>;
  website?: InputMaybe<StringFilter>;
};

export type SpaceRequestWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SpaceUpdateArgs = {
  data: SpaceUpdateInput;
  where: SpaceWhereUniqueInput;
};

export type SpaceUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<Scalars['String']['input']>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  badges?: InputMaybe<BadgeRelateToManyForUpdateInput>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingRef?: InputMaybe<Scalars['String']['input']>;
  billingScheduleId?: InputMaybe<Scalars['String']['input']>;
  classOffered?: InputMaybe<ClassOfferedRelateToManyForUpdateInput>;
  clients?: InputMaybe<ClientsAssociatedRelateToManyForUpdateInput>;
  coaches?: InputMaybe<CoachRelateToManyForUpdateInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  credits?: InputMaybe<CreditRelateToManyForUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  gallery1?: InputMaybe<ImageFieldInput>;
  gallery2?: InputMaybe<ImageFieldInput>;
  gallery3?: InputMaybe<ImageFieldInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  navBarColor?: InputMaybe<Scalars['String']['input']>;
  navBarTextColor?: InputMaybe<Scalars['String']['input']>;
  paymentLink?: InputMaybe<Scalars['String']['input']>;
  payments?: InputMaybe<PaymentRelateToManyForUpdateInput>;
  paymentsProvider?: InputMaybe<PaymentsProviderRelateToManyForUpdateInput>;
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  plans?: InputMaybe<PlanRelateToManyForUpdateInput>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  sessions?: InputMaybe<SessionRelateToManyForUpdateInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForUpdateInput>;
  summary?: InputMaybe<Scalars['String']['input']>;
  textPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  textSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<ImageFieldInput>;
  trialEndAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  usersWithAccess?: InputMaybe<UserBackofficeRelateToManyForUpdateInput>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type SpaceWhereInput = {
  AND?: InputMaybe<Array<SpaceWhereInput>>;
  NOT?: InputMaybe<Array<SpaceWhereInput>>;
  OR?: InputMaybe<Array<SpaceWhereInput>>;
  address?: InputMaybe<StringFilter>;
  address2?: InputMaybe<StringFilter>;
  backgroundColor?: InputMaybe<StringFilter>;
  badges?: InputMaybe<BadgeManyRelationFilter>;
  billingEmail?: InputMaybe<StringFilter>;
  billingRef?: InputMaybe<StringFilter>;
  billingScheduleId?: InputMaybe<StringFilter>;
  classOffered?: InputMaybe<ClassOfferedManyRelationFilter>;
  clients?: InputMaybe<ClientsAssociatedManyRelationFilter>;
  coaches?: InputMaybe<CoachManyRelationFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  credits?: InputMaybe<CreditManyRelationFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
  navBarColor?: InputMaybe<StringFilter>;
  navBarTextColor?: InputMaybe<StringFilter>;
  paymentLink?: InputMaybe<StringFilter>;
  payments?: InputMaybe<PaymentManyRelationFilter>;
  paymentsProvider?: InputMaybe<PaymentsProviderManyRelationFilter>;
  phoneCountryCode?: InputMaybe<StringFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  plan?: InputMaybe<StringFilter>;
  plans?: InputMaybe<PlanManyRelationFilter>;
  primaryColor?: InputMaybe<StringFilter>;
  secondaryColor?: InputMaybe<StringFilter>;
  sessions?: InputMaybe<SessionManyRelationFilter>;
  status?: InputMaybe<StringNullableFilter>;
  subscriptions?: InputMaybe<SessionSubscriptionManyRelationFilter>;
  summary?: InputMaybe<StringFilter>;
  textPrimaryColor?: InputMaybe<StringFilter>;
  textSecondaryColor?: InputMaybe<StringFilter>;
  trialEndAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  usersWithAccess?: InputMaybe<UserBackofficeManyRelationFilter>;
  website?: InputMaybe<StringFilter>;
};

export type SpaceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<StringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StripeLoginResponse = {
  __typename?: 'StripeLoginResponse';
  client_secret: Scalars['String']['output'];
};

export type StripePaymentIntentData = {
  __typename?: 'StripePaymentIntentData';
  client_secret: Scalars['String']['output'];
  ephemeralKeySecret: Scalars['String']['output'];
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ThreeDSecureUsage = {
  __typename?: 'ThreeDSecureUsage';
  supported: Scalars['Boolean']['output'];
};

export type TotalsValue = {
  __typename?: 'TotalsValue';
  before: Scalars['Float']['output'];
  current: Scalars['Float']['output'];
  diff: Scalars['Float']['output'];
};

export type UpdateAllSessionForEventBackofficeInput = {
  categories?: InputMaybe<SessionCategoryRelateToManyForUpdateInput>;
  coach?: InputMaybe<CoachRelateToOneForUpdateInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  finishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  limitQuote?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<ImageFieldOutput>;
  backoffice?: Maybe<Array<UserBackoffice>>;
  backofficeCount?: Maybe<Scalars['Int']['output']>;
  badges?: Maybe<BadgeItem>;
  birthday?: Maybe<Scalars['DateTime']['output']>;
  countryFrom?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  credits?: Maybe<Array<Credit>>;
  creditsCount?: Maybe<Scalars['Int']['output']>;
  devices?: Maybe<Array<Device>>;
  devicesCount?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firebaseUID?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAccessCMS?: Maybe<Scalars['Boolean']['output']>;
  lang?: Maybe<UserLangType>;
  lastName?: Maybe<Scalars['String']['output']>;
  password?: Maybe<PasswordState>;
  paymentPreference?: Maybe<Scalars['String']['output']>;
  spacesAssociated?: Maybe<Array<ClientsAssociated>>;
  spacesAssociatedCount?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<Array<SessionSubscription>>;
  subscriptionsCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
};


export type UserBackofficeArgs = {
  cursor?: InputMaybe<UserBackofficeWhereUniqueInput>;
  orderBy?: Array<UserBackofficeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserBackofficeWhereInput;
};


export type UserBackofficeCountArgs = {
  where?: UserBackofficeWhereInput;
};


export type UserCreditsArgs = {
  cursor?: InputMaybe<CreditWhereUniqueInput>;
  orderBy?: Array<CreditOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: CreditWhereInput;
};


export type UserCreditsCountArgs = {
  where?: CreditWhereInput;
};


export type UserDevicesArgs = {
  cursor?: InputMaybe<DeviceWhereUniqueInput>;
  orderBy?: Array<DeviceOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: DeviceWhereInput;
};


export type UserDevicesCountArgs = {
  where?: DeviceWhereInput;
};


export type UserSpacesAssociatedArgs = {
  cursor?: InputMaybe<ClientsAssociatedWhereUniqueInput>;
  orderBy?: Array<ClientsAssociatedOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ClientsAssociatedWhereInput;
};


export type UserSpacesAssociatedCountArgs = {
  where?: ClientsAssociatedWhereInput;
};


export type UserSubscriptionsArgs = {
  cursor?: InputMaybe<SessionSubscriptionWhereUniqueInput>;
  orderBy?: Array<SessionSubscriptionOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SessionSubscriptionWhereInput;
};


export type UserSubscriptionsCountArgs = {
  where?: SessionSubscriptionWhereInput;
};

export type UserAuthenticationWithPasswordFailure = {
  __typename?: 'UserAuthenticationWithPasswordFailure';
  message: Scalars['String']['output'];
};

export type UserAuthenticationWithPasswordResult = UserAuthenticationWithPasswordFailure | UserAuthenticationWithPasswordSuccess;

export type UserAuthenticationWithPasswordSuccess = {
  __typename?: 'UserAuthenticationWithPasswordSuccess';
  device?: Maybe<Device>;
  item: User;
  scope?: Maybe<Array<Maybe<UserBackoffice>>>;
  sessionToken: Scalars['String']['output'];
};

export type UserBackoffice = {
  __typename?: 'UserBackoffice';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  space?: Maybe<Space>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User>;
  user?: Maybe<User>;
};

export type UserBackofficeCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  space?: InputMaybe<SpaceRelateToOneForCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
  user?: InputMaybe<UserRelateToOneForCreateInput>;
};

export type UserBackofficeManyRelationFilter = {
  every?: InputMaybe<UserBackofficeWhereInput>;
  none?: InputMaybe<UserBackofficeWhereInput>;
  some?: InputMaybe<UserBackofficeWhereInput>;
};

export type UserBackofficeOrderByInput = {
  createdAt?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isAdmin?: InputMaybe<OrderDirection>;
  isBlocked?: InputMaybe<OrderDirection>;
  isOwner?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type UserBackofficeRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserBackofficeWhereUniqueInput>>;
  create?: InputMaybe<Array<UserBackofficeCreateInput>>;
};

export type UserBackofficeRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserBackofficeWhereUniqueInput>>;
  create?: InputMaybe<Array<UserBackofficeCreateInput>>;
  disconnect?: InputMaybe<Array<UserBackofficeWhereUniqueInput>>;
  set?: InputMaybe<Array<UserBackofficeWhereUniqueInput>>;
};

export type UserBackofficeUpdateArgs = {
  data: UserBackofficeUpdateInput;
  where: UserBackofficeWhereUniqueInput;
};

export type UserBackofficeUpdateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  isBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  isOwner?: InputMaybe<Scalars['Boolean']['input']>;
  space?: InputMaybe<SpaceRelateToOneForUpdateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  user?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type UserBackofficeWhereInput = {
  AND?: InputMaybe<Array<UserBackofficeWhereInput>>;
  NOT?: InputMaybe<Array<UserBackofficeWhereInput>>;
  OR?: InputMaybe<Array<UserBackofficeWhereInput>>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  id?: InputMaybe<IdFilter>;
  isAdmin?: InputMaybe<BooleanFilter>;
  isBlocked?: InputMaybe<BooleanFilter>;
  isOwner?: InputMaybe<BooleanFilter>;
  space?: InputMaybe<SpaceWhereInput>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
  user?: InputMaybe<UserWhereInput>;
};

export type UserBackofficeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<ImageFieldInput>;
  backoffice?: InputMaybe<UserBackofficeRelateToManyForCreateInput>;
  badges?: InputMaybe<BadgeItemRelateToOneForCreateInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  countryFrom?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForCreateInput>;
  credits?: InputMaybe<CreditRelateToManyForCreateInput>;
  devices?: InputMaybe<DeviceRelateToManyForCreateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebaseUID?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAccessCMS?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<UserLangType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentPreference?: InputMaybe<Scalars['String']['input']>;
  spacesAssociated?: InputMaybe<ClientsAssociatedRelateToManyForCreateInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForCreateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForCreateInput>;
};

export enum UserLangType {
  En = 'en',
  Es = 'es'
}

export type UserLangTypeNullableFilter = {
  equals?: InputMaybe<UserLangType>;
  in?: InputMaybe<Array<UserLangType>>;
  not?: InputMaybe<UserLangTypeNullableFilter>;
  notIn?: InputMaybe<Array<UserLangType>>;
};

export type UserManyRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserOrderByInput = {
  address?: InputMaybe<OrderDirection>;
  birthday?: InputMaybe<OrderDirection>;
  countryFrom?: InputMaybe<OrderDirection>;
  createdAt?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  firebaseUID?: InputMaybe<OrderDirection>;
  firstName?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isAccessCMS?: InputMaybe<OrderDirection>;
  lang?: InputMaybe<OrderDirection>;
  lastName?: InputMaybe<OrderDirection>;
  paymentPreference?: InputMaybe<OrderDirection>;
  state?: InputMaybe<OrderDirection>;
  stripeCustomerId?: InputMaybe<OrderDirection>;
  updatedAt?: InputMaybe<OrderDirection>;
};

export type UserRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCreateInput>>;
};

export type UserRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCreateInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserRelateToOneForCreateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  create?: InputMaybe<UserCreateInput>;
};

export type UserRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  create?: InputMaybe<UserCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSubscription = {
  __typename?: 'UserSubscription';
  avatar?: Maybe<SessionByBackofficeFile>;
  email: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<ImageFieldInput>;
  backoffice?: InputMaybe<UserBackofficeRelateToManyForUpdateInput>;
  badges?: InputMaybe<BadgeItemRelateToOneForUpdateInput>;
  birthday?: InputMaybe<Scalars['DateTime']['input']>;
  countryFrom?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<UserRelateToOneForUpdateInput>;
  credits?: InputMaybe<CreditRelateToManyForUpdateInput>;
  devices?: InputMaybe<DeviceRelateToManyForUpdateInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firebaseUID?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAccessCMS?: InputMaybe<Scalars['Boolean']['input']>;
  lang?: InputMaybe<UserLangType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentPreference?: InputMaybe<Scalars['String']['input']>;
  spacesAssociated?: InputMaybe<ClientsAssociatedRelateToManyForUpdateInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  subscriptions?: InputMaybe<SessionSubscriptionRelateToManyForUpdateInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<UserRelateToOneForUpdateInput>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  address?: InputMaybe<StringFilter>;
  backoffice?: InputMaybe<UserBackofficeManyRelationFilter>;
  badges?: InputMaybe<BadgeItemWhereInput>;
  birthday?: InputMaybe<DateTimeNullableFilter>;
  countryFrom?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  createdBy?: InputMaybe<UserWhereInput>;
  credits?: InputMaybe<CreditManyRelationFilter>;
  devices?: InputMaybe<DeviceManyRelationFilter>;
  email?: InputMaybe<StringFilter>;
  firebaseUID?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isAccessCMS?: InputMaybe<BooleanFilter>;
  lang?: InputMaybe<UserLangTypeNullableFilter>;
  lastName?: InputMaybe<StringFilter>;
  password?: InputMaybe<PasswordFilter>;
  paymentPreference?: InputMaybe<StringNullableFilter>;
  spacesAssociated?: InputMaybe<ClientsAssociatedManyRelationFilter>;
  state?: InputMaybe<StringNullableFilter>;
  stripeCustomerId?: InputMaybe<StringFilter>;
  subscriptions?: InputMaybe<SessionSubscriptionManyRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type UserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type VerifyExistEmailResult = {
  __typename?: 'VerifyExistEmailResult';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  photoURL?: Maybe<Scalars['String']['output']>;
  providerData: Array<ProviderData>;
  uid: Scalars['String']['output'];
};

export type VerifyStripeAccountResult = {
  __typename?: 'VerifyStripeAccountResult';
  charges_enabled: Scalars['Boolean']['output'];
  details_submitted: Scalars['Boolean']['output'];
};

export type VerifyTokenResult = {
  __typename?: 'VerifyTokenResult';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  space: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type CreateClientMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createUser?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  ) | null };

export type UpdateClientMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  data: UserUpdateInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateUser?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  ) | null };

export type CreatePaymentMutationVariables = Exact<{
  data: PaymentCreateInput;
}>;


export type CreatePaymentMutation = { __typename?: 'Mutation', createPayment?: { __typename?: 'Payment', id: string, status?: string | null } | null };

export type CreateCreditMutationVariables = Exact<{
  data: CreditCreateInput;
}>;


export type CreateCreditMutation = { __typename?: 'Mutation', createCredit?: (
    { __typename?: 'Credit' }
    & { ' $fragmentRefs'?: { 'CreditFragmentFragment': CreditFragmentFragment } }
  ) | null };

export type UpdateCreditMutationVariables = Exact<{
  creditId: Scalars['ID']['input'];
  data: CreditUpdateInput;
}>;


export type UpdateCreditMutation = { __typename?: 'Mutation', updateCredit?: (
    { __typename?: 'Credit' }
    & { ' $fragmentRefs'?: { 'CreditFragmentFragment': CreditFragmentFragment } }
  ) | null };

export type GetClientsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetClientsQuery = { __typename?: 'Query', space?: { __typename?: 'Space', clients?: Array<(
      { __typename?: 'ClientsAssociated' }
      & { ' $fragmentRefs'?: { 'ClientsAssociatedFragmentFragment': ClientsAssociatedFragmentFragment } }
    )> | null } | null };

export type GetClientByIdQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetClientByIdQuery = { __typename?: 'Query', user?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'ClientCompleteFragmentFragment': ClientCompleteFragmentFragment } }
  ) | null };

export type GetClientsNotificationsBaseQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientsNotificationsBaseQuery = { __typename?: 'Query', space?: { __typename?: 'Space', clientsCount?: number | null, clients?: Array<(
      { __typename?: 'ClientsAssociated' }
      & { ' $fragmentRefs'?: { 'ClientsAssociatedFragmentFragment': ClientsAssociatedFragmentFragment } }
    )> | null } | null };

export type GetClientsNotificationsActiveQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientsNotificationsActiveQuery = { __typename?: 'Query', space?: { __typename?: 'Space', clientsCount?: number | null, clients?: Array<(
      { __typename?: 'ClientsAssociated' }
      & { ' $fragmentRefs'?: { 'ClientsAssociatedFragmentFragment': ClientsAssociatedFragmentFragment } }
    )> | null } | null };

export type GetClientsNotificationsInactiveQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetClientsNotificationsInactiveQuery = { __typename?: 'Query', space?: { __typename?: 'Space', clientsCount?: number | null, clients?: Array<(
      { __typename?: 'ClientsAssociated' }
      & { ' $fragmentRefs'?: { 'ClientsAssociatedFragmentFragment': ClientsAssociatedFragmentFragment } }
    )> | null } | null };

export type GetSessionClientByIdQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSessionClientByIdQuery = { __typename?: 'Query', user?: { __typename?: 'User', subscriptionsCount?: number | null, subscriptions?: Array<{ __typename?: 'SessionSubscription', id: string, sessionForSubscribe?: (
        { __typename?: 'Session' }
        & { ' $fragmentRefs'?: { 'SessionFragmentFragment': SessionFragmentFragment } }
      ) | null }> | null } | null };

export type GetCreditsByClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetCreditsByClientQuery = { __typename?: 'Query', credits?: Array<(
    { __typename?: 'Credit' }
    & { ' $fragmentRefs'?: { 'CreditFragmentFragment': CreditFragmentFragment } }
  )> | null };

export type CreateCoachMutationVariables = Exact<{
  data: CoachCreateInput;
}>;


export type CreateCoachMutation = { __typename?: 'Mutation', createCoach?: (
    { __typename?: 'Coach' }
    & { ' $fragmentRefs'?: { 'CoachFragmentFragment': CoachFragmentFragment } }
  ) | null };

export type UpdateCoachByIdMutationVariables = Exact<{
  coachID: Scalars['ID']['input'];
  data: CoachUpdateInput;
}>;


export type UpdateCoachByIdMutation = { __typename?: 'Mutation', updateCoach?: (
    { __typename?: 'Coach' }
    & { ' $fragmentRefs'?: { 'CoachFragmentFragment': CoachFragmentFragment } }
  ) | null };

export type UpdateCoachMutationVariables = Exact<{
  coachID: Scalars['ID']['input'];
  data: CoachUpdateInput;
}>;


export type UpdateCoachMutation = { __typename?: 'Mutation', updateCoach?: { __typename?: 'Coach', id: string, status?: string | null } | null };

export type GetCoachesQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetCoachesQuery = { __typename?: 'Query', coaches?: Array<(
    { __typename?: 'Coach' }
    & { ' $fragmentRefs'?: { 'CoachFragmentFragment': CoachFragmentFragment } }
  )> | null };

export type GetCoachByIdQueryVariables = Exact<{
  coachId: Scalars['ID']['input'];
}>;


export type GetCoachByIdQuery = { __typename?: 'Query', coach?: (
    { __typename?: 'Coach' }
    & { ' $fragmentRefs'?: { 'CoachFragmentFragment': CoachFragmentFragment } }
  ) | null };

export type GetSessionCoachByIdQueryVariables = Exact<{
  coachId: Scalars['ID']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetSessionCoachByIdQuery = { __typename?: 'Query', totalCount?: number | null, sessions?: Array<(
    { __typename?: 'Session' }
    & { ' $fragmentRefs'?: { 'SessionFragmentFragment': SessionFragmentFragment } }
  )> | null };

export type TodaySessionsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  day: Scalars['String']['input'];
}>;


export type TodaySessionsQuery = { __typename?: 'Query', sessionsListBackoffice?: Array<(
    { __typename?: 'SessionByBackoffice' }
    & { ' $fragmentRefs'?: { 'SessionBoardFragmentFragment': SessionBoardFragmentFragment } }
  ) | null> | null };

export type TotalCustomerQueryVariables = Exact<{
  data: CreateReportTotals;
}>;


export type TotalCustomerQuery = { __typename?: 'Query', reportTotalClients: { __typename?: 'ReportTotalClients', active: number, inactive: number, totals: { __typename?: 'TotalsValue', current: number, before: number, diff: number } } };

export type TotalRevenueQueryVariables = Exact<{
  data: CreateReportTotals;
}>;


export type TotalRevenueQuery = { __typename?: 'Query', reportTotalRevenue: { __typename?: 'ReportTotalRevenue', currentTotalByClient: number, beforeTotalByClient: number, totals: { __typename?: 'TotalsValue', current: number, before: number, diff: number }, revenueByClient: { __typename?: 'TotalsValue', current: number, before: number, diff: number }, currentPayments: Array<{ __typename?: 'Payment', id: string, method?: string | null, amount?: any | null, createdAt?: any | null, user?: { __typename?: 'User', id: string, fullName?: string | null } | null, credit?: { __typename?: 'Credit', id: string, plan?: { __typename?: 'Plan', id: string, name?: string | null } | null } | null }> } };

export type AllActivityQueryQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
}>;


export type AllActivityQueryQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, subscriptions?: Array<{ __typename?: 'SessionSubscription', id: string, sessionForSubscribe?: { __typename?: 'Session', startedAt?: any | null, coach?: { __typename?: 'Coach', id: string, fullName?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null } | null } | null }> | null } | null };

export type GetValidRenewalsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetValidRenewalsQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, credits?: Array<{ __typename?: 'Credit', id: string, expiredAt?: any | null, user?: { __typename?: 'User', id: string } | null }> | null } | null };

export type GetUpcomingRenewalsQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetUpcomingRenewalsQuery = { __typename?: 'Query', space?: { __typename?: 'Space', id: string, credits?: Array<{ __typename?: 'Credit', id: string, status?: string | null, updatedAt?: any | null, creditBuy?: number | null, expiredAt?: any | null, plan?: { __typename?: 'Plan', id: string, name?: string | null } | null, user?: (
        { __typename?: 'User' }
        & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
      ) | null }> | null } | null };

export type CreateNotificationsMutationVariables = Exact<{
  data: CreateNotificationsInput;
}>;


export type CreateNotificationsMutation = { __typename?: 'Mutation', sendNotification: Array<any | null> };

export type CreateSessionMutationVariables = Exact<{
  data: SessionCreateInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession?: (
    { __typename?: 'Session' }
    & { ' $fragmentRefs'?: { 'SessionFragmentFragment': SessionFragmentFragment } }
  ) | null };

export type CreateRepeatSessionMutationVariables = Exact<{
  data: RepeatSessionCreateInput;
}>;


export type CreateRepeatSessionMutation = { __typename?: 'Mutation', createRepeatSession?: { __typename?: 'RepeatSession', id: string } | null };

export type UpdateAllSessionForEventBackofficeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UpdateAllSessionForEventBackofficeInput;
}>;


export type UpdateAllSessionForEventBackofficeMutation = { __typename?: 'Mutation', updateAllSessionForEventBackoffice?: Array<{ __typename?: 'Session', id: string } | null> | null };

export type UpdateSessionBackofficeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: SessionUpdateInput;
}>;


export type UpdateSessionBackofficeMutation = { __typename?: 'Mutation', updateSession?: { __typename?: 'Session', id: string } | null };

export type DeleteSessionBackofficeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSessionBackofficeMutation = { __typename?: 'Mutation', updateSession?: { __typename?: 'Session', id: string } | null };

export type DeleteRepeatSessionBackofficeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteRepeatSessionBackofficeMutation = { __typename?: 'Mutation', deleteAllSessionForEventBackoffice?: Array<{ __typename?: 'Session', id: string } | null> | null };

export type CreateSessionSubscriptionMutationVariables = Exact<{
  data: CreateSubscriptionForSessionData;
}>;


export type CreateSessionSubscriptionMutation = { __typename?: 'Mutation', createSubscriptionForSession?: { __typename?: 'SessionSubscription', id: string, sessionForSubscribe?: { __typename?: 'Session', id: string, name?: string | null } | null } | null };

export type UpdateSessionSubscriptionMutationVariables = Exact<{
  data: Array<SessionSubscriptionUpdateArgs> | SessionSubscriptionUpdateArgs;
}>;


export type UpdateSessionSubscriptionMutation = { __typename?: 'Mutation', updateSessionSubscriptions?: Array<{ __typename?: 'SessionSubscription', id: string } | null> | null };

export type DeleteSessionSubscriptionMutationVariables = Exact<{
  sessionId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type DeleteSessionSubscriptionMutation = { __typename?: 'Mutation', deleteSubscriptionForSession?: { __typename?: 'SessionSubscription', id: string } | null };

export type SessionsListBackofficeQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  day: Scalars['String']['input'];
  time: FilterTimeEnum;
}>;


export type SessionsListBackofficeQuery = { __typename?: 'Query', sessionsListBackoffice?: Array<(
    { __typename?: 'SessionByBackoffice' }
    & { ' $fragmentRefs'?: { 'SessionBoardFragmentFragment': SessionBoardFragmentFragment } }
  ) | null> | null };

export type PostUpdateClassMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: ClassOfferedUpdateInput;
}>;


export type PostUpdateClassMutation = { __typename?: 'Mutation', updateClassOffered?: (
    { __typename?: 'ClassOffered' }
    & { ' $fragmentRefs'?: { 'ClassOfferedFragmentFragment': ClassOfferedFragmentFragment } }
  ) | null };

export type PostCreatePlanMutationVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  points: Scalars['Int']['input'];
  price: Scalars['Decimal']['input'];
  duration: Scalars['Int']['input'];
  categories?: InputMaybe<SessionCategoryRelateToManyForCreateInput>;
}>;


export type PostCreatePlanMutation = { __typename?: 'Mutation', createPlan?: (
    { __typename?: 'Plan' }
    & { ' $fragmentRefs'?: { 'PlanFragmentFragment': PlanFragmentFragment } }
  ) | null };

export type PostUpdatePlanMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: PlanUpdateInput;
}>;


export type PostUpdatePlanMutation = { __typename?: 'Mutation', updatePlan?: (
    { __typename?: 'Plan' }
    & { ' $fragmentRefs'?: { 'PlanFragmentFragment': PlanFragmentFragment } }
  ) | null };

export type PostCreateSessionCategoryMutationVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type PostCreateSessionCategoryMutation = { __typename?: 'Mutation', createSessionCategory?: { __typename?: 'SessionCategory', id: string, name?: string | null, status?: string | null, plansCount?: number | null } | null };

export type PostUpdateSessionCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: SessionCategoryUpdateInput;
}>;


export type PostUpdateSessionCategoryMutation = { __typename?: 'Mutation', updateSessionCategory?: { __typename?: 'SessionCategory', id: string, name?: string | null, status?: string | null, plansCount?: number | null } | null };

export type PostDeleteSessionCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostDeleteSessionCategoryMutation = { __typename?: 'Mutation', deleteSessionCategory?: { __typename?: 'SessionCategory', id: string } | null };

export type PostCreateBadgeMutationVariables = Exact<{
  data: BadgeCreateInput;
}>;


export type PostCreateBadgeMutation = { __typename?: 'Mutation', createBadge?: (
    { __typename?: 'Badge' }
    & { ' $fragmentRefs'?: { 'BadgeFragmentFragment': BadgeFragmentFragment } }
  ) | null };

export type PostUpdateBadgeMutationVariables = Exact<{
  badgeId: Scalars['ID']['input'];
  data: BadgeUpdateInput;
}>;


export type PostUpdateBadgeMutation = { __typename?: 'Mutation', updateBadge?: (
    { __typename?: 'Badge' }
    & { ' $fragmentRefs'?: { 'BadgeFragmentFragment': BadgeFragmentFragment } }
  ) | null };

export type PostDeleteBadgeMutationVariables = Exact<{
  badgeId: Scalars['ID']['input'];
}>;


export type PostDeleteBadgeMutation = { __typename?: 'Mutation', deleteBadge?: (
    { __typename?: 'Badge' }
    & { ' $fragmentRefs'?: { 'BadgeFragmentFragment': BadgeFragmentFragment } }
  ) | null };

export type PostCreateBadgeItemMutationVariables = Exact<{
  data: BadgeItemCreateInput;
}>;


export type PostCreateBadgeItemMutation = { __typename?: 'Mutation', createBadgeItem?: (
    { __typename?: 'BadgeItem' }
    & { ' $fragmentRefs'?: { 'BadgeItemFragmentFragment': BadgeItemFragmentFragment } }
  ) | null };

export type PostUpdateBadgeItemMutationVariables = Exact<{
  badgeId: Scalars['ID']['input'];
  data: BadgeItemUpdateInput;
}>;


export type PostUpdateBadgeItemMutation = { __typename?: 'Mutation', updateBadgeItem?: (
    { __typename?: 'BadgeItem' }
    & { ' $fragmentRefs'?: { 'BadgeItemFragmentFragment': BadgeItemFragmentFragment } }
  ) | null };

export type PostDeleteBadgeItemMutationVariables = Exact<{
  badgeId: Scalars['ID']['input'];
}>;


export type PostDeleteBadgeItemMutation = { __typename?: 'Mutation', deleteBadgeItem?: (
    { __typename?: 'BadgeItem' }
    & { ' $fragmentRefs'?: { 'BadgeItemFragmentFragment': BadgeItemFragmentFragment } }
  ) | null };

export type CreateNewUserBackofficeMutationVariables = Exact<{
  data: UserBackofficeCreateInput;
}>;


export type CreateNewUserBackofficeMutation = { __typename?: 'Mutation', createUserBackoffice?: (
    { __typename?: 'UserBackoffice' }
    & { ' $fragmentRefs'?: { 'UserBackofficeFragmentFragment': UserBackofficeFragmentFragment } }
  ) | null };

export type UpdateUserDataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UserUpdateInput;
}>;


export type UpdateUserDataMutation = { __typename?: 'Mutation', updateUser?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  ) | null };

export type UpdateNewUserBackofficeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: UserBackofficeUpdateInput;
}>;


export type UpdateNewUserBackofficeMutation = { __typename?: 'Mutation', updateUserBackoffice?: (
    { __typename?: 'UserBackoffice' }
    & { ' $fragmentRefs'?: { 'UserBackofficeFragmentFragment': UserBackofficeFragmentFragment } }
  ) | null };

export type VerifyStripeAccountMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type VerifyStripeAccountMutation = { __typename?: 'Mutation', verifyStripeAccount: { __typename?: 'VerifyStripeAccountResult', charges_enabled: boolean, details_submitted: boolean } };

export type CreateStripeAccountMutationVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type CreateStripeAccountMutation = { __typename?: 'Mutation', createStripeAccount: { __typename?: 'AccountResponse', accountLink: string } };

export type LoginStripeLinkAccountMutationVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type LoginStripeLinkAccountMutation = { __typename?: 'Mutation', loginStripeAccount: { __typename?: 'StripeLoginResponse', client_secret: string } };

export type LinkStripeLinkAccountMutationVariables = Exact<{
  accountId: Scalars['String']['input'];
}>;


export type LinkStripeLinkAccountMutation = { __typename?: 'Mutation', linkStripeAccount: { __typename?: 'AccountResponse', accountLink: string } };

export type UpdatePaymentsProviderMutationVariables = Exact<{
  paymentProviderId: Scalars['ID']['input'];
}>;


export type UpdatePaymentsProviderMutation = { __typename?: 'Mutation', updatePaymentsProvider?: { __typename?: 'PaymentsProvider', id: string } | null };

export type GetPlansBySpaceQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetPlansBySpaceQuery = { __typename?: 'Query', plans?: Array<(
    { __typename?: 'Plan' }
    & { ' $fragmentRefs'?: { 'PlanFragmentFragment': PlanFragmentFragment } }
  )> | null };

export type GetSessionsCategoriesBySpaceQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetSessionsCategoriesBySpaceQuery = { __typename?: 'Query', sessionCategories?: Array<{ __typename?: 'SessionCategory', id: string, name?: string | null, status?: string | null, plansCount?: number | null }> | null };

export type GetBadgesBySpaceQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type GetBadgesBySpaceQuery = { __typename?: 'Query', badges?: Array<(
    { __typename?: 'Badge' }
    & { ' $fragmentRefs'?: { 'BadgeFragmentFragment': BadgeFragmentFragment } }
  )> | null };

export type UserBackofficesQueryVariables = Exact<{
  spaceId: Scalars['ID']['input'];
}>;


export type UserBackofficesQuery = { __typename?: 'Query', userBackoffices?: Array<(
    { __typename?: 'UserBackoffice' }
    & { ' $fragmentRefs'?: { 'UserBackofficeFragmentFragment': UserBackofficeFragmentFragment } }
  )> | null };

export type AuthenticateUserWithFirebaseMutationVariables = Exact<{
  firebaseToken: Scalars['String']['input'];
}>;


export type AuthenticateUserWithFirebaseMutation = { __typename?: 'Mutation', authenticateBackofficeUserWithFirebase?: { __typename?: 'UserAuthenticationWithPasswordFailure', message: string } | { __typename?: 'UserAuthenticationWithPasswordSuccess', sessionToken: string, scope?: Array<{ __typename?: 'UserBackoffice', id: string, isAdmin?: boolean | null, isBlocked?: boolean | null, isOwner?: boolean | null, space?: { __typename?: 'Space', id: string, name?: string | null, summary?: string | null, email?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, paymentLink?: string | null, website?: string | null, amenities?: Array<string> | null, billingEmail?: string | null, billingRef?: string | null, billingScheduleId?: string | null, trialEndAt?: any | null, status?: string | null, plan?: string | null, paymentsProviderCount?: number | null, gallery1?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, gallery2?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, gallery3?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, classOffered?: Array<(
          { __typename?: 'ClassOffered' }
          & { ' $fragmentRefs'?: { 'ClassOfferedFragmentFragment': ClassOfferedFragmentFragment } }
        )> | null, badges?: Array<{ __typename?: 'Badge', id: string, name?: string | null, items?: Array<(
            { __typename?: 'BadgeItem' }
            & { ' $fragmentRefs'?: { 'BadgeItemFragmentFragment': BadgeItemFragmentFragment } }
          )> | null }> | null, thumbnail?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, paymentsProvider?: Array<{ __typename?: 'PaymentsProvider', id: string, provider?: string | null, referenceId?: string | null, status?: string | null }> | null } | null } | null> | null, item: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, fullName?: string | null, email?: string | null, state?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null } } | null };

export type UpdateSpaceMutationVariables = Exact<{
  spaceId: Scalars['ID']['input'];
  data: SpaceUpdateInput;
}>;


export type UpdateSpaceMutation = { __typename?: 'Mutation', updateSpace?: { __typename?: 'Space', id: string, name?: string | null, summary?: string | null, email?: string | null, phoneCountryCode?: string | null, phoneNumber?: string | null, address?: string | null, paymentLink?: string | null, website?: string | null, amenities?: Array<string> | null, billingEmail?: string | null, billingRef?: string | null, trialEndAt?: any | null, billingScheduleId?: string | null, plan?: string | null, status?: string | null, paymentsProviderCount?: number | null, gallery1?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, gallery2?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, gallery3?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, classOffered?: Array<(
      { __typename?: 'ClassOffered' }
      & { ' $fragmentRefs'?: { 'ClassOfferedFragmentFragment': ClassOfferedFragmentFragment } }
    )> | null, badges?: Array<{ __typename?: 'Badge', id: string, name?: string | null, items?: Array<(
        { __typename?: 'BadgeItem' }
        & { ' $fragmentRefs'?: { 'BadgeItemFragmentFragment': BadgeItemFragmentFragment } }
      )> | null }> | null, thumbnail?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, paymentsProvider?: Array<{ __typename?: 'PaymentsProvider', id: string, provider?: string | null, referenceId?: string | null, status?: string | null }> | null } | null };

export type UpdateFirebaseUidMutationVariables = Exact<{
  token: Scalars['String']['input'];
  firebaseUID: Scalars['String']['input'];
}>;


export type UpdateFirebaseUidMutation = { __typename?: 'Mutation', completeProfileBackoffice?: boolean | null };

export type GetFirebaseUserByEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetFirebaseUserByEmailMutation = { __typename?: 'Mutation', verifyExistEmail?: { __typename?: 'VerifyExistEmailResult', uid: string, email: string, displayName?: string | null, photoURL?: string | null, emailVerified: boolean, providerData: Array<{ __typename?: 'ProviderData', uid: string, providerId: string, displayName: string }> } | null };

export type CreateSpaceRequestMutationVariables = Exact<{
  data: SpaceRequestCreateInput;
}>;


export type CreateSpaceRequestMutation = { __typename?: 'Mutation', createSpaceRequest?: { __typename?: 'SpaceRequest', id: string } | null };

export type VerifyTokenQueryQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type VerifyTokenQueryQuery = { __typename?: 'Query', verifyToken?: { __typename?: 'VerifyTokenResult', id: string, email: string, firstName: string, lastName: string, space: string } | null };

export type ClassOfferedFragmentFragment = { __typename?: 'ClassOffered', id: string, name?: string | null, short_summary?: string | null, image?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, schedules?: Array<{ __typename?: 'ClassOfferedSchedule', day?: string | null, time?: string | null, startTime?: any | null, endTime?: any | null }> | null } & { ' $fragmentName'?: 'ClassOfferedFragmentFragment' };

export type PlanFragmentFragment = { __typename?: 'Plan', id: string, name?: string | null, points?: number | null, price?: any | null, duration?: number | null, status?: string | null, creditCount?: number | null, categoriesCount?: number | null, categories?: Array<{ __typename?: 'SessionCategory', id: string, name?: string | null }> | null } & { ' $fragmentName'?: 'PlanFragmentFragment' };

export type CreditFragmentFragment = { __typename?: 'Credit', id: string, creditUsed?: number | null, creditBuy?: number | null, openAt?: any | null, totalPrice?: any | null, expiredAt?: any | null, status?: string | null, subscriptionsCount?: number | null, paymentMethod?: string | null, plan?: (
    { __typename?: 'Plan' }
    & { ' $fragmentRefs'?: { 'PlanFragmentFragment': PlanFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'CreditFragmentFragment' };

export type UserFragmentFragment = { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, state?: string | null, paymentPreference?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, devices?: Array<{ __typename?: 'Device', id: string, token?: string | null, device_manufacturer?: string | null, device_model?: string | null, device_name?: string | null, device_platform?: string | null, device_system_version?: string | null }> | null } & { ' $fragmentName'?: 'UserFragmentFragment' };

export type ClientsAssociatedFragmentFragment = { __typename?: 'ClientsAssociated', id: string, user?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'ClientsAssociatedFragmentFragment' };

export type BadgeItemFragmentFragment = { __typename?: 'BadgeItem', id: string, name?: string | null, color?: string | null, icon?: string | null, userCount?: number | null, badge?: { __typename?: 'Badge', id: string, name?: string | null } | null } & { ' $fragmentName'?: 'BadgeItemFragmentFragment' };

export type ClientCompleteFragmentFragment = { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, state?: string | null, paymentPreference?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null, badges?: (
    { __typename?: 'BadgeItem' }
    & { ' $fragmentRefs'?: { 'BadgeItemFragmentFragment': BadgeItemFragmentFragment } }
  ) | null, lastCredit?: Array<(
    { __typename?: 'Credit' }
    & { ' $fragmentRefs'?: { 'CreditFragmentFragment': CreditFragmentFragment } }
  )> | null } & { ' $fragmentName'?: 'ClientCompleteFragmentFragment' };

export type SessionFragmentFragment = { __typename?: 'Session', id: string, name?: string | null, description?: string | null, color?: string | null, limitQuote?: number | null, cost?: number | null, startedAt?: any | null, finishedAt?: any | null, status?: string | null, createdAt?: any | null, isBacklog?: boolean | null, subscriptionsCount?: number | null, subscriptions?: Array<{ __typename?: 'SessionSubscription', id: string, confirmedAt?: any | null, creditCost?: number | null, createdAt?: any | null, status?: string | null, user?: { __typename?: 'User', id: string, fullName?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null } | null }> | null, coach?: { __typename?: 'Coach', id: string, fullName?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null } | null, rootEvent?: { __typename?: 'RepeatSession', id: string, limitQuote?: number | null, cost?: number | null, startedAt?: any | null, finishedAt?: any | null, interval?: number | null, frequency?: string | null, daysRepeat?: Array<RepeatSessionDaysRepeatType> | null, finishType?: string | null, count?: number | null, finishedRepeatAt?: any | null } | null, categories?: Array<{ __typename?: 'SessionCategory', id: string, name?: string | null, status?: string | null }> | null } & { ' $fragmentName'?: 'SessionFragmentFragment' };

export type SessionBoardFragmentFragment = { __typename?: 'SessionByBackoffice', id: string, name?: string | null, description?: string | null, color?: string | null, limitQuote?: number | null, cost?: number | null, startedAt?: string | null, finishedAt?: string | null, status?: string | null, createdAt?: string | null, isBacklog?: boolean | null, subscriptionsCount?: number | null, subscriptions?: Array<{ __typename?: 'SessionSubscriptionBackOffice', id: string, confirmedAt?: string | null, creditCost?: number | null, createdAt?: string | null, status?: string | null, user?: { __typename?: 'UserSubscription', id: string, fullName: string, avatar?: { __typename?: 'SessionByBackofficeFile', id?: string | null, url: string } | null } | null } | null> | null, coach?: { __typename?: 'SessionByBackofficeCoach', id: string, fullName: string, avatar: { __typename?: 'SessionByBackofficeFile', id?: string | null, url: string } } | null, rootEvent?: { __typename?: 'SessionByBackofficeRootEvent', id: string, limitQuote?: number | null, cost?: number | null, startedAt?: string | null, finishedAt?: string | null, interval?: number | null, frequency?: string | null, daysRepeat?: Array<string | null> | null, finishType?: string | null, count?: number | null, finishedRepeatAt?: string | null } | null, categories?: Array<{ __typename?: 'SessionCategory', id: string, name?: string | null, status?: string | null } | null> | null } & { ' $fragmentName'?: 'SessionBoardFragmentFragment' };

export type CoachFragmentFragment = { __typename?: 'Coach', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, status?: string | null, avatar?: { __typename?: 'ImageFieldOutput', id: string, url: string } | null } & { ' $fragmentName'?: 'CoachFragmentFragment' };

export type BadgeFragmentFragment = { __typename?: 'Badge', id: string, name?: string | null, items?: Array<{ __typename?: 'BadgeItem', id: string, name?: string | null, color?: string | null, icon?: string | null, userCount?: number | null }> | null } & { ' $fragmentName'?: 'BadgeFragmentFragment' };

export type UserBackofficeFragmentFragment = { __typename?: 'UserBackoffice', id: string, isAdmin?: boolean | null, isBlocked?: boolean | null, isOwner?: boolean | null, user?: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  ) | null } & { ' $fragmentName'?: 'UserBackofficeFragmentFragment' };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserByEmailQuery = { __typename?: 'Query', users?: Array<(
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'UserFragmentFragment': UserFragmentFragment } }
  )> | null };

export const ClassOfferedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassOfferedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOffered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_summary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<ClassOfferedFragmentFragment, unknown>;
export const UserFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<UserFragmentFragment, unknown>;
export const ClientsAssociatedFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientsAssociatedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientsAssociated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<ClientsAssociatedFragmentFragment, unknown>;
export const BadgeItemFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<BadgeItemFragmentFragment, unknown>;
export const PlanFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}}]} as unknown as DocumentNode<PlanFragmentFragment, unknown>;
export const CreditFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditUsed"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"openAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}}]} as unknown as DocumentNode<CreditFragmentFragment, unknown>;
export const ClientCompleteFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientCompleteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastCredit"},"name":{"kind":"Name","value":"credits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"valid","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreditFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditUsed"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"openAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}}]} as unknown as DocumentNode<ClientCompleteFragmentFragment, unknown>;
export const SessionFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SessionFragmentFragment, unknown>;
export const SessionBoardFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionBoardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SessionByBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SessionBoardFragmentFragment, unknown>;
export const CoachFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<CoachFragmentFragment, unknown>;
export const BadgeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Badge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}}]}}]} as unknown as DocumentNode<BadgeFragmentFragment, unknown>;
export const UserBackofficeFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBackofficeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<UserBackofficeFragmentFragment, unknown>;
export const CreateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<UpdateClientMutation, UpdateClientMutationVariables>;
export const CreatePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const CreateCreditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCredit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreditCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCredit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreditFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditUsed"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"openAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}}]} as unknown as DocumentNode<CreateCreditMutation, CreateCreditMutationVariables>;
export const UpdateCreditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCredit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"creditId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreditUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCredit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"creditId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreditFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditUsed"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"openAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}}]} as unknown as DocumentNode<UpdateCreditMutation, UpdateCreditMutationVariables>;
export const GetClientsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClients"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clients"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientsAssociatedFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientsAssociatedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientsAssociated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<GetClientsQuery, GetClientsQueryVariables>;
export const GetClientByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientCompleteFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditUsed"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"openAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientCompleteFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastCredit"},"name":{"kind":"Name","value":"credits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"valid","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreditFragment"}}]}}]}}]} as unknown as DocumentNode<GetClientByIdQuery, GetClientByIdQueryVariables>;
export const GetClientsNotificationsBaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientsNotificationsBase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientsAssociatedFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientsAssociatedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientsAssociated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<GetClientsNotificationsBaseQuery, GetClientsNotificationsBaseQueryVariables>;
export const GetClientsNotificationsActiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientsNotificationsActive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"credits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiredAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"credits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiredAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientsAssociatedFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientsAssociatedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientsAssociated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<GetClientsNotificationsActiveQuery, GetClientsNotificationsActiveQueryVariables>;
export const GetClientsNotificationsInactiveDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getClientsNotificationsInactive"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"credits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"every"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiredAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"clients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"contains"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"mode"},"value":{"kind":"EnumValue","value":"insensitive"}}]}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"credits"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"every"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"expiredAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClientsAssociatedFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClientsAssociatedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClientsAssociated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<GetClientsNotificationsInactiveQuery, GetClientsNotificationsInactiveQueryVariables>;
export const GetSessionClientByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSessionClientById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionForSubscribe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetSessionClientByIdQuery, GetSessionClientByIdQueryVariables>;
export const GetCreditsByClientDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCreditsByClient"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CreditFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CreditFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"creditUsed"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"openAt"}},{"kind":"Field","name":{"kind":"Name","value":"totalPrice"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}}]} as unknown as DocumentNode<GetCreditsByClientQuery, GetCreditsByClientQueryVariables>;
export const CreateCoachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCoach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CoachCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<CreateCoachMutation, CreateCoachMutationVariables>;
export const UpdateCoachByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCoachById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coachID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CoachUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coachID"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UpdateCoachByIdMutation, UpdateCoachByIdMutationVariables>;
export const UpdateCoachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCoach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coachID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CoachUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCoach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coachID"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateCoachMutation, UpdateCoachMutationVariables>;
export const GetCoachesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCoaches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coaches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetCoachesQuery, GetCoachesQueryVariables>;
export const GetCoachByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCoachById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coachId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"coach"},"name":{"kind":"Name","value":"coach"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coachId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CoachFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CoachFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Coach"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GetCoachByIdQuery, GetCoachByIdQueryVariables>;
export const GetSessionCoachByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSessionCoachById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"coachId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"totalCount"},"name":{"kind":"Name","value":"sessionsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"coach"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coachId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"finishedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"sessions"},"name":{"kind":"Name","value":"sessions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"coach"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"coachId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"finishedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"finishedAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<GetSessionCoachByIdQuery, GetSessionCoachByIdQueryVariables>;
export const TodaySessionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TodaySessions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"day"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionsListBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"spaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"day"},"value":{"kind":"Variable","name":{"kind":"Name","value":"day"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"EnumValue","value":"DAY"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionBoardFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionBoardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SessionByBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<TodaySessionsQuery, TodaySessionsQueryVariables>;
export const TotalCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TotalCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportTotals"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportTotalClients"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"before"}},{"kind":"Field","name":{"kind":"Name","value":"diff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"inactive"}}]}}]}}]} as unknown as DocumentNode<TotalCustomerQuery, TotalCustomerQueryVariables>;
export const TotalRevenueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TotalRevenue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateReportTotals"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportTotalRevenue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"before"}},{"kind":"Field","name":{"kind":"Name","value":"diff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"revenueByClient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"current"}},{"kind":"Field","name":{"kind":"Name","value":"before"}},{"kind":"Field","name":{"kind":"Name","value":"diff"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentPayments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"credit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentTotalByClient"}},{"kind":"Field","name":{"kind":"Name","value":"beforeTotalByClient"}}]}}]}}]} as unknown as DocumentNode<TotalRevenueQuery, TotalRevenueQueryVariables>;
export const AllActivityQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllActivityQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"pending","block":false},{"kind":"StringValue","value":"confirmed","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionForSubscribe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AllActivityQueryQuery, AllActivityQueryQueryVariables>;
export const GetValidRenewalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidRenewals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"valid","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidRenewalsQuery, GetValidRenewalsQueryVariables>;
export const GetUpcomingRenewalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUpcomingRenewals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"valid","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditBuy"}},{"kind":"Field","name":{"kind":"Name","value":"expiredAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<GetUpcomingRenewalsQuery, GetUpcomingRenewalsQueryVariables>;
export const CreateNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNotificationsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<CreateNotificationsMutation, CreateNotificationsMutationVariables>;
export const CreateSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Session"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CreateSessionMutation, CreateSessionMutationVariables>;
export const CreateRepeatSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateRepeatSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RepeatSessionCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createRepeatSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateRepeatSessionMutation, CreateRepeatSessionMutationVariables>;
export const UpdateAllSessionForEventBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAllSessionForEventBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateAllSessionForEventBackofficeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAllSessionForEventBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateAllSessionForEventBackofficeMutation, UpdateAllSessionForEventBackofficeMutationVariables>;
export const UpdateSessionBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSessionBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSessionBackofficeMutation, UpdateSessionBackofficeMutationVariables>;
export const DeleteSessionBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSessionBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"deleted","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSessionBackofficeMutation, DeleteSessionBackofficeMutationVariables>;
export const DeleteRepeatSessionBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteRepeatSessionBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteAllSessionForEventBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteRepeatSessionBackofficeMutation, DeleteRepeatSessionBackofficeMutationVariables>;
export const CreateSessionSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSessionSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSubscriptionForSessionData"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSubscriptionForSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sessionForSubscribe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSessionSubscriptionMutation, CreateSessionSubscriptionMutationVariables>;
export const UpdateSessionSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSessionSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionSubscriptionUpdateArgs"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSessionSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSessionSubscriptionMutation, UpdateSessionSubscriptionMutationVariables>;
export const DeleteSessionSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSessionSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSubscriptionForSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSessionSubscriptionMutation, DeleteSessionSubscriptionMutationVariables>;
export const SessionsListBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SessionsListBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"day"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FilterTimeEnum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionsListBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"spaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"day"},"value":{"kind":"Variable","name":{"kind":"Name","value":"day"}}},{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SessionBoardFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SessionBoardFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SessionByBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"isBacklog"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionsCount"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"creditCost"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coach"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"rootEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"limitQuote"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"interval"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"daysRepeat"}},{"kind":"Field","name":{"kind":"Name","value":"finishType"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"finishedRepeatAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SessionsListBackofficeQuery, SessionsListBackofficeQueryVariables>;
export const PostUpdateClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostUpdateClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOfferedUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateClassOffered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClassOfferedFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassOfferedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOffered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_summary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}}]} as unknown as DocumentNode<PostUpdateClassMutation, PostUpdateClassMutationVariables>;
export const PostCreatePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostCreatePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"points"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"price"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"duration"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"categories"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionCategoryRelateToManyForCreateInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"points"},"value":{"kind":"Variable","name":{"kind":"Name","value":"points"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"price"},"value":{"kind":"Variable","name":{"kind":"Name","value":"price"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"duration"},"value":{"kind":"Variable","name":{"kind":"Name","value":"duration"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"categories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"categories"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}}]} as unknown as DocumentNode<PostCreatePlanMutation, PostCreatePlanMutationVariables>;
export const PostUpdatePlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostUpdatePlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlanUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}}]} as unknown as DocumentNode<PostUpdatePlanMutation, PostUpdatePlanMutationVariables>;
export const PostCreateSessionCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostCreateSessionCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSessionCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"connect"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"plansCount"}}]}}]}}]} as unknown as DocumentNode<PostCreateSessionCategoryMutation, PostCreateSessionCategoryMutationVariables>;
export const PostUpdateSessionCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostUpdateSessionCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SessionCategoryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSessionCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"plansCount"}}]}}]}}]} as unknown as DocumentNode<PostUpdateSessionCategoryMutation, PostUpdateSessionCategoryMutationVariables>;
export const PostDeleteSessionCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostDeleteSessionCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSessionCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PostDeleteSessionCategoryMutation, PostDeleteSessionCategoryMutationVariables>;
export const PostCreateBadgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostCreateBadge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBadge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Badge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}}]}}]} as unknown as DocumentNode<PostCreateBadgeMutation, PostCreateBadgeMutationVariables>;
export const PostUpdateBadgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostUpdateBadge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBadge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Badge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}}]}}]} as unknown as DocumentNode<PostUpdateBadgeMutation, PostUpdateBadgeMutationVariables>;
export const PostDeleteBadgeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostDeleteBadge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBadge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Badge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}}]}}]} as unknown as DocumentNode<PostDeleteBadgeMutation, PostDeleteBadgeMutationVariables>;
export const PostCreateBadgeItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostCreateBadgeItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createBadgeItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PostCreateBadgeItemMutation, PostCreateBadgeItemMutationVariables>;
export const PostUpdateBadgeItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostUpdateBadgeItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBadgeItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PostUpdateBadgeItemMutation, PostUpdateBadgeItemMutationVariables>;
export const PostDeleteBadgeItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PostDeleteBadgeItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteBadgeItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"badgeId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<PostDeleteBadgeItemMutation, PostDeleteBadgeItemMutationVariables>;
export const CreateNewUserBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNewUserBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserBackofficeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUserBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBackofficeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBackofficeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<CreateNewUserBackofficeMutation, CreateNewUserBackofficeMutationVariables>;
export const UpdateUserDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<UpdateUserDataMutation, UpdateUserDataMutationVariables>;
export const UpdateNewUserBackofficeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateNewUserBackoffice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserBackofficeUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBackofficeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBackofficeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<UpdateNewUserBackofficeMutation, UpdateNewUserBackofficeMutationVariables>;
export const VerifyStripeAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyStripeAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyStripeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"charges_enabled"}},{"kind":"Field","name":{"kind":"Name","value":"details_submitted"}}]}}]}}]} as unknown as DocumentNode<VerifyStripeAccountMutation, VerifyStripeAccountMutationVariables>;
export const CreateStripeAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStripeAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStripeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"spaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountLink"}}]}}]}}]} as unknown as DocumentNode<CreateStripeAccountMutation, CreateStripeAccountMutationVariables>;
export const LoginStripeLinkAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginStripeLinkAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginStripeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"spaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client_secret"}}]}}]}}]} as unknown as DocumentNode<LoginStripeLinkAccountMutation, LoginStripeLinkAccountMutationVariables>;
export const LinkStripeLinkAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LinkStripeLinkAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"linkStripeAccount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountLink"}}]}}]}}]} as unknown as DocumentNode<LinkStripeLinkAccountMutation, LinkStripeLinkAccountMutationVariables>;
export const UpdatePaymentsProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentsProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"paymentProviderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentsProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"paymentProviderId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"StringValue","value":"completed","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentsProviderMutation, UpdatePaymentsProviderMutationVariables>;
export const GetPlansBySpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlansBySpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"points"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PlanFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PlanFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Plan"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"points"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"creditCount"}},{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"categoriesCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"active","block":false}}]}}]}}]}]}}]} as unknown as DocumentNode<GetPlansBySpaceQuery, GetPlansBySpaceQueryVariables>;
export const GetSessionsCategoriesBySpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSessionsCategoriesBySpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionCategories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"EnumValue","value":"asc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"plansCount"}}]}}]}}]} as unknown as DocumentNode<GetSessionsCategoriesBySpaceQuery, GetSessionsCategoriesBySpaceQueryVariables>;
export const GetBadgesBySpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBadgesBySpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"badges"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Badge"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}}]}}]}}]} as unknown as DocumentNode<GetBadgesBySpaceQuery, GetBadgesBySpaceQueryVariables>;
export const UserBackofficesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserBackoffices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userBackoffices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserBackofficeFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserBackofficeFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserBackoffice"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}}]} as unknown as DocumentNode<UserBackofficesQuery, UserBackofficesQueryVariables>;
export const AuthenticateUserWithFirebaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthenticateUserWithFirebase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firebaseToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticateBackofficeUserWithFirebase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firebaseToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserAuthenticationWithPasswordSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}},{"kind":"Field","name":{"kind":"Name","value":"scope"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isBlocked"}},{"kind":"Field","name":{"kind":"Name","value":"isOwner"}},{"kind":"Field","name":{"kind":"Name","value":"space"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"amenities"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"billingRef"}},{"kind":"Field","name":{"kind":"Name","value":"billingScheduleId"}},{"kind":"Field","name":{"kind":"Name","value":"trialEndAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"gallery1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gallery2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gallery3"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classOffered"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClassOfferedFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentsProviderCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"stripe","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"completed","block":false}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"paymentsProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"stripe","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserAuthenticationWithPasswordFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassOfferedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOffered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_summary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AuthenticateUserWithFirebaseMutation, AuthenticateUserWithFirebaseMutationVariables>;
export const UpdateSpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpaceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSpace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"paymentLink"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"amenities"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"billingRef"}},{"kind":"Field","name":{"kind":"Name","value":"trialEndAt"}},{"kind":"Field","name":{"kind":"Name","value":"billingScheduleId"}},{"kind":"Field","name":{"kind":"Name","value":"plan"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"gallery1"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gallery2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gallery3"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"classOffered"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ClassOfferedFragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"badges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BadgeItemFragment"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentsProviderCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"stripe","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"completed","block":false}}]}}]}}]},{"kind":"Field","name":{"kind":"Name","value":"paymentsProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"stripe","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"provider"}},{"kind":"Field","name":{"kind":"Name","value":"referenceId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ClassOfferedFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ClassOffered"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"short_summary"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"day"}},{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BadgeItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BadgeItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}},{"kind":"Field","name":{"kind":"Name","value":"userCount"}},{"kind":"Field","name":{"kind":"Name","value":"badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateSpaceMutation, UpdateSpaceMutationVariables>;
export const UpdateFirebaseUidDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFirebaseUID"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firebaseUID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeProfileBackoffice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firebaseUID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firebaseUID"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<UpdateFirebaseUidMutation, UpdateFirebaseUidMutationVariables>;
export const GetFirebaseUserByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetFirebaseUserByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyExistEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"photoURL"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}},{"kind":"Field","name":{"kind":"Name","value":"providerData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<GetFirebaseUserByEmailMutation, GetFirebaseUserByEmailMutationVariables>;
export const CreateSpaceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSpaceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpaceRequestCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSpaceRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSpaceRequestMutation, CreateSpaceRequestMutationVariables>;
export const VerifyTokenQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VerifyTokenQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"space"}}]}}]}}]} as unknown as DocumentNode<VerifyTokenQueryQuery, VerifyTokenQueryQueryVariables>;
export const GetUserByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreference"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"device_manufacturer"}},{"kind":"Field","name":{"kind":"Name","value":"device_model"}},{"kind":"Field","name":{"kind":"Name","value":"device_name"}},{"kind":"Field","name":{"kind":"Name","value":"device_platform"}},{"kind":"Field","name":{"kind":"Name","value":"device_system_version"}}]}}]}}]} as unknown as DocumentNode<GetUserByEmailQuery, GetUserByEmailQueryVariables>;